// Fichier généré. Ne pas éditer à la main.

export const THEME = {
  light: {
    small: {
      brand: 'legacy',
      mode: 'light',
      breakpoint: 'small',
      colors: {
        black: '#1F2635',
        'border.brand': '#1A3D32',
        'border.brand-alt': '#8EDED0',
        'border.disabled': '#28272514',
        'border.divider': '#2827251F',
        'border.error': '#BE171B',
        'border.focused': '#2B8176',
        'border.info': '#2C6CBF',
        'border.interactive': '#3A9488',
        'border.inverse.disabled': '#FDFDFC66',
        'border.inverse.divider': '#FDFDFC33',
        'border.inverse.interactive': '#64BAAF',
        'border.inverse.primary': '#FFFFFF',
        'border.inverse.secondary': '#FDFDFC66',
        'border.inverse.selected': '#64BAAF',
        'border.inverse.strong': '#FFFFFF',
        'border.primary': '#28272566',
        'border.secondary': '#28272529',
        'border.secondary-1.default': '#D2E4A8',
        'border.secondary-1.strong': '#344417',
        'border.secondary-1.subtle': '#F4F8E8',
        'border.secondary-2.default': '#F2D87A',
        'border.secondary-2.strong': '#6A4B17',
        'border.secondary-2.subtle': '#FDF8E8',
        'border.secondary-3.default': '#E39464',
        'border.secondary-3.strong': '#5C2314',
        'border.secondary-3.subtle': '#FDF0E8',
        'border.secondary-4.default': '#D97A73',
        'border.secondary-4.strong': '#521F1B',
        'border.secondary-4.subtle': '#FDE8EC',
        'border.secondary-5.default': '#8F6B97',
        'border.secondary-5.low': '#B8A4D0',
        'border.secondary-5.medium': '#64466C',
        'border.secondary-5.strong': '#3A2640',
        'border.secondary-5.subtle': '#F3EEF7',
        'border.selected': '#3A9488',
        'border.strong': '#1F2635',
        'border.success': '#5B9D13',
        'border.warning': '#BB8713',
        'component.button.bg.hover': '#FDFDFC33',
        'component.button.bg.inverted': '#FFFFFF',
        'component.button.bg.pressed': '#FDFDFC14',
        'component.button.bg.primary': '#1F2635',
        'component.button.bg.secondary': '#E8F8F4',
        'component.button.bg.tertiary': '#F5F3F0',
        'component.button.bg.transparent': '#28272599',
        'component.button.border.tertiary': '#1F2635',
        'component.button.icon.tertiary': '#1F2635',
        'component.button.label.tertiary': '#1F2635',
        'concept.ambassador.border': '#F5EA93',
        'concept.ambassador.icon': '#BB8713',
        'concept.ambassador.surface.default': '#D8AD1A',
        'concept.ambassador.surface.strong': '#6A4019',
        'concept.ambassador.surface.subtle': '#FCFBEA',
        'concept.ambassador.text': '#956213',
        'concept.exoneration.border': '#8EDED0',
        'concept.exoneration.icon': '#1F2635',
        'concept.exoneration.surface.default': '#3A9488',
        'concept.exoneration.surface.low': '#B8ECE0',
        'concept.exoneration.surface.medium': '#236B61',
        'concept.exoneration.surface.strong': '#1F2635',
        'concept.exoneration.surface.subtle': '#E8F8F4',
        'concept.exoneration.text': '#1F2635',
        'concept.pension.border': '#ADCDF7',
        'concept.pension.icon': '#2C6CBF',
        'concept.pension.surface.default': '#3383EB',
        'concept.pension.surface.strong': '#15253D',
        'concept.pension.surface.subtle': '#EBF3FE',
        'concept.pension.text-on-dark': '#EBF3FE',
        'concept.pension.text-on-light': '#255594',
        'concept.plan.free.icon-on-surface': '#1F2635',
        'concept.plan.free.surface.default': '#3383EB',
        'concept.plan.free.surface.low': '#ADCDF7',
        'concept.plan.free.surface.medium': '#255594',
        'concept.plan.free.surface.strong': '#15253D',
        'concept.plan.free.surface.subtle': '#EBF3FE',
        'concept.plan.free.text-on-surface': '#1F2635',
        'concept.plan.premium.accent': '#F7E9AB',
        'concept.plan.premium.border': '#CFC1E1',
        'concept.plan.premium.icon-on-surface': '#7A5882',
        'concept.plan.premium.surface.default': '#8F6B97',
        'concept.plan.premium.surface.low': '#CFC1E1',
        'concept.plan.premium.surface.medium': '#64466C',
        'concept.plan.premium.surface.strong': '#3A2640',
        'concept.plan.premium.surface.subtle': '#F3EEF7',
        'concept.plan.premium.text-on-surface': '#64466C',
        'concept.trust-club.border': '#FFDDDD',
        'concept.trust-club.icon': '#FFA9AB',
        'concept.trust-club.surface.default': '#FFA9AB',
        'concept.trust-club.surface.strong': '#3E2D30',
        'concept.trust-club.surface.subtle': '#FFF7F7',
        'concept.trust-club.text-on-dark': '#FFF7F7',
        'concept.trust-club.text-on-light': '#9F6B6E',
        'gradient.bottom-tab-bar-end': '#FEFEFDB2',
        'gradient.bottom-tab-bar-start': '#FEFEFD00',
        'gradient.primary': '#FFFFFF00',
        'icon.brand': '#1F2635',
        'icon.brand-alt': '#8EDED0',
        'icon.disabled': '#28272566',
        'icon.emphasized': '#2B8176',
        'icon.error': '#BE171B',
        'icon.info': '#2C6CBF',
        'icon.interactive': '#3A9488',
        'icon.inverse.disabled': '#FDFDFC99',
        'icon.inverse.interactive': '#64BAAF',
        'icon.inverse.on-selected': '#3A9488',
        'icon.inverse.primary': '#FFFFFF',
        'icon.inverse.secondary': '#FDFDFC',
        'icon.primary': '#1F2635',
        'icon.secondary': '#6B6861',
        'icon.secondary-1.default': '#88A750',
        'icon.secondary-1.low': '#D2E4A8',
        'icon.secondary-1.medium': '#5C7530',
        'icon.secondary-1.strong': '#344417',
        'icon.secondary-1.subtle': '#F4F8E8',
        'icon.secondary-2.default': '#EECA60',
        'icon.secondary-2.low': '#F7E9AB',
        'icon.secondary-2.medium': '#D4A03A',
        'icon.secondary-2.strong': '#6A4B17',
        'icon.secondary-2.subtle': '#FDF8E8',
        'icon.secondary-3.default': '#E39464',
        'icon.secondary-3.low': '#F8CAAA',
        'icon.secondary-3.medium': '#BE6539',
        'icon.secondary-3.strong': '#5C2314',
        'icon.secondary-3.subtle': '#FDF0E8',
        'icon.secondary-4.default': '#D97A73',
        'icon.secondary-4.low': '#F1ADB2',
        'icon.secondary-4.medium': '#9B4138',
        'icon.secondary-4.strong': '#521F1B',
        'icon.secondary-4.subtle': '#FDE8EC',
        'icon.secondary-5.default': '#8F6B97',
        'icon.secondary-5.low': '#B8A4D0',
        'icon.secondary-5.medium': '#64466C',
        'icon.secondary-5.strong': '#3A2640',
        'icon.secondary-5.subtle': '#F3EEF7',
        'icon.selected': '#3A9488',
        'icon.success': '#457714',
        'icon.tertiary': '#C6C3B9',
        'icon.warning': '#BB8713',
        page: '#FFFFFF',
        'shadow.inner': '#FDFDFC66',
        'shadow.lg': '#28272529',
        'shadow.md': '#2827251F',
        'shadow.sm': '#28272514',
        'shadow.xl': '#28272533',
        'shadow.xs': '#2827250A',
        'state-layer.hover': '#28272514',
        'state-layer.hover-alt': '#28272514',
        'state-layer.hover-brand': '#B8ECE033',
        'state-layer.hover-on-color': '#28272533',
        'state-layer.inverse.hover': '#FDFDFC14',
        'state-layer.inverse.hover-brand': '#B8ECE033',
        'state-layer.inverse.hover-on-color': '#FDFDFC33',
        'state-layer.inverse.press': '#FDFDFC29',
        'state-layer.inverse.press-brand': '#B8ECE066',
        'state-layer.inverse.press-on-color': '#28272566',
        'state-layer.press': '#28272529',
        'state-layer.press-alt': '#28272529',
        'state-layer.press-brand': '#B8ECE066',
        'state-layer.press-on-color': '#28272566',
        'surface.brand.bold': '#1F2635',
        'surface.brand.bold-alt': '#0E2720',
        'surface.brand.default': '#3A9488',
        'surface.brand.default-alt': '#3A9488',
        'surface.brand.secondary-1.default': '#88A750',
        'surface.brand.secondary-1.low': '#B8D47E',
        'surface.brand.secondary-1.medium': '#5C7530',
        'surface.brand.secondary-1.strong': '#344417',
        'surface.brand.secondary-1.subtle': '#E7F0CE',
        'surface.brand.secondary-1.translucent.default': '#D2E4A833',
        'surface.brand.secondary-1.translucent.low': '#D2E4A829',
        'surface.brand.secondary-1.translucent.medium': '#D2E4A866',
        'surface.brand.secondary-1.translucent.strong': '#D2E4A899',
        'surface.brand.secondary-1.translucent.subtle': '#D2E4A81F',
        'surface.brand.secondary-2.default': '#F2D87A',
        'surface.brand.secondary-2.low': '#F7E9AB',
        'surface.brand.secondary-2.medium': '#EBBB4D',
        'surface.brand.secondary-2.strong': '#6A4B17',
        'surface.brand.secondary-2.subtle': '#F9EECC',
        'surface.brand.secondary-2.translucent.default': '#F2D87A33',
        'surface.brand.secondary-2.translucent.low': '#F2D87A29',
        'surface.brand.secondary-2.translucent.medium': '#F2D87A66',
        'surface.brand.secondary-2.translucent.strong': '#F2D87A99',
        'surface.brand.secondary-2.translucent.subtle': '#F2D87A1F',
        'surface.brand.secondary-3.default': '#E39464',
        'surface.brand.secondary-3.low': '#F8CAAA',
        'surface.brand.secondary-3.medium': '#BE6539',
        'surface.brand.secondary-3.strong': '#5C2314',
        'surface.brand.secondary-3.subtle': '#FBDDD0',
        'surface.brand.secondary-3.translucent.default': '#F8CAAA33',
        'surface.brand.secondary-3.translucent.low': '#F8CAAA29',
        'surface.brand.secondary-3.translucent.medium': '#F8CAAA66',
        'surface.brand.secondary-3.translucent.strong': '#F8CAAA99',
        'surface.brand.secondary-3.translucent.subtle': '#F8CAAA1F',
        'surface.brand.secondary-4.default': '#D97A73',
        'surface.brand.secondary-4.low': '#F1ADB2',
        'surface.brand.secondary-4.medium': '#9B4138',
        'surface.brand.secondary-4.strong': '#521F1B',
        'surface.brand.secondary-4.subtle': '#F9D1D8',
        'surface.brand.secondary-4.translucent.default': '#F5C2CB33',
        'surface.brand.secondary-4.translucent.low': '#F5C2CB29',
        'surface.brand.secondary-4.translucent.medium': '#F5C2CB66',
        'surface.brand.secondary-4.translucent.strong': '#F5C2CB99',
        'surface.brand.secondary-4.translucent.subtle': '#F5C2CB1F',
        'surface.brand.secondary-5.default': '#8F6B97',
        'surface.brand.secondary-5.low': '#B8A4D0',
        'surface.brand.secondary-5.medium': '#64466C',
        'surface.brand.secondary-5.strong': '#3A2640',
        'surface.brand.secondary-5.subtle': '#E5DAEF',
        'surface.brand.secondary-5.translucent.default': '#CFC1E133',
        'surface.brand.secondary-5.translucent.low': '#CFC1E129',
        'surface.brand.secondary-5.translucent.medium': '#CFC1E166',
        'surface.brand.secondary-5.translucent.strong': '#CFC1E199',
        'surface.brand.secondary-5.translucent.subtle': '#CFC1E11F',
        'surface.brand.strong': '#1F2635',
        'surface.brand.strong-alt': '#1A3D32',
        'surface.brand.subtle': '#E8F8F4',
        'surface.brand.subtle-alt': '#E8F8F4',
        'surface.brand.translucent.bold': '#B8ECE066',
        'surface.brand.translucent.bold-alt': '#B8ECE066',
        'surface.brand.translucent.default': '#B8ECE033',
        'surface.brand.translucent.strong': '#B8ECE066',
        'surface.brand.translucent.strong-alt': '#B8ECE066',
        'surface.brand.translucent.subtle': '#B8ECE014',
        'surface.default': '#FFFFFF',
        'surface.disabled': '#2827251F',
        'surface.error.default': '#F53E42',
        'surface.error.low': '#FFA9AB',
        'surface.error.medium': '#BE171B',
        'surface.error.strong': '#470809',
        'surface.error.subtle': '#FFE1E2',
        'surface.error.translucent.default': '#F53E4266',
        'surface.error.translucent.strong': '#F53E4299',
        'surface.error.translucent.subtle': '#F53E4233',
        'surface.info.default': '#3383EB',
        'surface.info.low': '#85B5F3',
        'surface.info.medium': '#255594',
        'surface.info.strong': '#121A27',
        'surface.info.subtle': '#EBF3FE',
        'surface.info.translucent.default': '#3383EB66',
        'surface.info.translucent.strong': '#3383EB99',
        'surface.info.translucent.subtle': '#3383EB33',
        'surface.interactive': '#3A9488',
        'surface.inverse.default': '#1F2635',
        'surface.inverse.disabled': '#FDFDFC33',
        'surface.inverse.primary-neutral': '#9B988C',
        'surface.inverse.secondary-neutral': '#C6C3B9',
        'surface.inverse.selected': '#E8F8F4',
        'surface.inverse.selected-strong': '#FFFFFF',
        'surface.inverse.tertiary-neutral': '#EEECE7',
        'surface.overlay': '#28272566',
        'surface.primary': '#E8F8F4',
        'surface.primary-alt': '#E8F8F4',
        'surface.primary-neutral': '#F9F8F6',
        'surface.secondary': '#B8ECE0',
        'surface.secondary-alt': '#B4ECDF',
        'surface.secondary-neutral': '#F5F3F0',
        'surface.selected': '#E8F8F4',
        'surface.selected-strong': '#3A9488',
        'surface.strong-neutral': '#3E3B38',
        'surface.success.default': '#77C41E',
        'surface.success.low': '#B3EC6A',
        'surface.success.medium': '#457714',
        'surface.success.strong': '#182C07',
        'surface.success.subtle': '#E8FACD',
        'surface.success.translucent.default': '#77C41E66',
        'surface.success.translucent.strong': '#77C41E99',
        'surface.success.translucent.subtle': '#77C41E33',
        'surface.tertiary': '#8EDED0',
        'surface.tertiary-alt': '#8EDED0',
        'surface.tertiary-neutral': '#EEECE7',
        'surface.translucent.default': '#2827250A',
        'surface.translucent.disabled': '#2827251F',
        'surface.translucent.primary': '#B8ECE014',
        'surface.translucent.primary-alt': '#B8ECE014',
        'surface.translucent.primary-neutral': '#28272514',
        'surface.translucent.secondary': '#B8ECE029',
        'surface.translucent.secondary-alt': '#B8ECE029',
        'surface.translucent.secondary-neutral': '#28272529',
        'surface.translucent.selected': '#B8ECE029',
        'surface.translucent.strong-neutral': '#28272566',
        'surface.translucent.tertiary': '#B8ECE066',
        'surface.translucent.tertiary-alt': '#B8ECE033',
        'surface.translucent.tertiary-neutral': '#28272533',
        'surface.warning.default': '#D8AD1A',
        'surface.warning.low': '#EDD441',
        'surface.warning.medium': '#956213',
        'surface.warning.strong': '#3D220B',
        'surface.warning.subtle': '#F9F6C8',
        'surface.warning.translucent.default': '#D8AD1A66',
        'surface.warning.translucent.strong': '#D8AD1A99',
        'surface.warning.translucent.subtle': '#D8AD1A33',
        'text.brand': '#1F2635',
        'text.brand-alt': '#8EDED0',
        'text.disabled': '#28272566',
        'text.emphasized': '#2B8176',
        'text.error': '#BE171B',
        'text.info': '#2C6CBF',
        'text.interactive': '#3A9488',
        'text.inverse.disabled': '#FDFDFC66',
        'text.inverse.emphasized': '#B8ECE0',
        'text.inverse.interactive': '#64BAAF',
        'text.inverse.primary': '#FFFFFF',
        'text.inverse.secondary': '#FDFDFCCC',
        'text.primary': '#1F2635',
        'text.secondary': '#6B6861',
        'text.secondary-1.default': '#88A750',
        'text.secondary-1.low': '#B8D47E',
        'text.secondary-1.medium': '#5C7530',
        'text.secondary-1.strong': '#344417',
        'text.secondary-1.subtle': '#F4F8E8',
        'text.secondary-2.default': '#F2D87A',
        'text.secondary-2.low': '#F7E9AB',
        'text.secondary-2.medium': '#EBBB4D',
        'text.secondary-2.strong': '#6A4B17',
        'text.secondary-2.subtle': '#FDF8E8',
        'text.secondary-3.default': '#E39464',
        'text.secondary-3.low': '#F8CAAA',
        'text.secondary-3.medium': '#BE6539',
        'text.secondary-3.strong': '#5C2314',
        'text.secondary-3.subtle': '#FDF0E8',
        'text.secondary-4.default': '#D97A73',
        'text.secondary-4.low': '#F1ADB2',
        'text.secondary-4.medium': '#9B4138',
        'text.secondary-4.strong': '#521F1B',
        'text.secondary-4.subtle': '#FDE8EC',
        'text.secondary-5.default': '#8F6B97',
        'text.secondary-5.low': '#B8A4D0',
        'text.secondary-5.medium': '#64466C',
        'text.secondary-5.strong': '#3A2640',
        'text.secondary-5.subtle': '#F3EEF7',
        'text.selected': '#3A9488',
        'text.success': '#457714',
        'text.tertiary': '#C6C3B9',
        'text.warning': '#BB8713',
        white: '#FFFFFF',
        'white-label.footer.footer-bg': '#F5F3F0',
        'white-label.header.bg': '#EEECE7',
        'white-label.header.on-header': '#1F2635',
        'white-label.headerSubtext': '#FFFFFF',
        'white-label.highlight': '#FFFFFF',
        'white-label.highlightText': '#FFFFFF',
        'white-label.notificationLogoBackground': '#FFFFFF',
        'white-label.publish-button.bg.header-bar': '#1F2635',
        'white-label.publish-button.bg.mobile-bottom-tab-bar': '#1F2635',
        'white-label.publish-button.icon.header-bar': '#FFFFFF',
        'white-label.publish-button.icon.mobile-bottom-tab-bar': '#FFFFFF',
        'white-label.publish-button.label.primary': '#FFFFFF',
        'white-label.splash': '#B8ECE0',
        'white-label.theme.icon.on-brand-accent': '#FFFFFF',
        'white-label.theme.surface.accent': '#1F2635',
        'white-label.theme.surface.primary': '#EEECE7',
        'white-label.theme.text.on-brand-accent': '#FFFFFF',
      },
      responsive: {
        'border-width.bold': '4',
        'border-width.emphasized': '2',
        'border-width.standard': '1.5',
        'border-width.subtle': '1',
        'motion.distance.component-enter': '8',
        'motion.distance.feedback': '2',
        'motion.distance.overlay-enter': '12',
        'motion.distance.page-enter': '16',
        'motion.duration.component-transition': '[object Object]',
        'motion.duration.feedback': '[object Object]',
        'motion.duration.micro-transition': '[object Object]',
        'motion.duration.overlay-transition': '[object Object]',
        'motion.duration.page-transition': '[object Object]',
        'motion.duration.passive': '[object Object]',
        'motion.easing.continuous': '0,0,1,1',
        'motion.easing.emphasize': '0.05000000074505806,0.699999988079071,0.10000000149011612,1',
        'motion.easing.enter': '0,0,0,1',
        'motion.easing.exit': '0.4000000059604645,0,1,1',
        'motion.easing.move': '0.20000000298023224,0,0,1',
        'motion.scale.emphasize': '1.0199999809265137',
        'motion.scale.enter': '0.9599999785423279',
        'motion.scale.press': '0.9800000190734863',
        'motion.stagger.relaxed': '[object Object]',
        'motion.stagger.standard': '[object Object]',
        'motion.stagger.tight': '[object Object]',
        'radius.component.fields.input': '16',
        'radius.component.publish-button.button-radius': '8',
        'radius.full': '1000',
        'radius.lg': '16',
        'radius.md': '12',
        'radius.none': '0',
        'radius.sm': '8',
        'radius.xl': '24',
        'radius.xs': '4',
        'radius.xxl': '32',
        'radius.xxs': '2',
        'shadow.blur.lg': '16',
        'shadow.blur.md': '8',
        'shadow.blur.sm': '4',
        'shadow.blur.xl': '24',
        'shadow.blur.xs': '2',
        'shadow.offset-y.lg': '4',
        'shadow.offset-y.md': '2',
        'shadow.offset-y.sm': '1',
        'shadow.offset-y.xl': '8',
        'shadow.offset-y.xs': '1',
        'sizing.body.max-width': '767',
        'sizing.body.min-width': '320',
        'sizing.component.button.height.large': '56',
        'sizing.component.button.height.large-icn-button': '48',
        'sizing.component.button.height.medium': '40',
        'sizing.component.button.height.small': '32',
        'sizing.component.header.max-width': '767',
        'sizing.component.header.min-width': '320',
        'sizing.general.0': '0',
        'sizing.general.x0,25': '1',
        'sizing.general.x0,5': '2',
        'sizing.general.x1': '4',
        'sizing.general.x10': '40',
        'sizing.general.x100': '400',
        'sizing.general.x12': '48',
        'sizing.general.x120': '480',
        'sizing.general.x14': '56',
        'sizing.general.x140': '560',
        'sizing.general.x150': '600',
        'sizing.general.x16': '64',
        'sizing.general.x160': '640',
        'sizing.general.x18': '72',
        'sizing.general.x180': '720',
        'sizing.general.x2': '8',
        'sizing.general.x20': '80',
        'sizing.general.x200': '800',
        'sizing.general.x22': '88',
        'sizing.general.x24': '96',
        'sizing.general.x3': '12',
        'sizing.general.x30': '120',
        'sizing.general.x36': '144',
        'sizing.general.x4': '16',
        'sizing.general.x40': '160',
        'sizing.general.x5': '20',
        'sizing.general.x50': '200',
        'sizing.general.x6': '24',
        'sizing.general.x60': '240',
        'sizing.general.x7': '28',
        'sizing.general.x70': '280',
        'sizing.general.x8': '32',
        'sizing.general.x80': '320',
        'sizing.general.x90': '360',
        'sizing.icon.default': '24',
        'sizing.icon.lg': '32',
        'sizing.icon.s': '16',
        'sizing.icon.sm': '20',
        'sizing.icon.xl': '56',
        'sizing.icon.xs': '12',
        'spacing.general.0': '0',
        'spacing.general.x0,5': '2',
        'spacing.general.x1': '4',
        'spacing.general.x10': '40',
        'spacing.general.x12': '48',
        'spacing.general.x14': '56',
        'spacing.general.x16': '64',
        'spacing.general.x18': '72',
        'spacing.general.x2': '8',
        'spacing.general.x20': '80',
        'spacing.general.x22': '88',
        'spacing.general.x24': '96',
        'spacing.general.x3': '12',
        'spacing.general.x30': '120',
        'spacing.general.x36': '144',
        'spacing.general.x4': '16',
        'spacing.general.x5': '20',
        'spacing.general.x6': '24',
        'spacing.general.x7': '28',
        'spacing.general.x8': '32',
        'spacing.semantic.bottom-safe-zone': '36',
        'spacing.semantic.line-height-fix': '2',
        'spacing.semantic.page-margin': '16',
        'typography.font-size.body.base': '16',
        'typography.font-size.body.caption-base': '10',
        'typography.font-size.body.caption-large': '12',
        'typography.font-size.body.large': '18',
        'typography.font-size.body.small': '14',
        'typography.font-size.body.x-large': '20',
        'typography.font-size.body.x-small': '12',
        'typography.font-size.header.display-1': '48',
        'typography.font-size.header.display-2': '56',
        'typography.font-size.header.large': '40',
        'typography.font-size.header.medium': '28',
        'typography.font-size.header.small': '24',
        'typography.font-size.header.x-small': '20',
        'typography.font-size.link.link-base': '16',
        'typography.font-size.link.link-large': '20',
        'typography.font-size.link.link-small': '14',
        'typography.letter-spacing.body.base': '0',
        'typography.letter-spacing.body.caption': '0',
        'typography.letter-spacing.body.large': '0',
        'typography.letter-spacing.body.small': '0',
        'typography.letter-spacing.body.x-large': '0',
        'typography.letter-spacing.body.x-small': '0',
        'typography.letter-spacing.header.display-1': '0',
        'typography.letter-spacing.header.display-2': '0',
        'typography.letter-spacing.header.large': '0',
        'typography.letter-spacing.header.medium': '0',
        'typography.letter-spacing.header.small': '0',
        'typography.letter-spacing.header.x-small': '0',
      },
      styles: {
        header: {
          'display-2': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '56',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'display-1': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '48',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '40',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '40', letterSpacing: '0', lineHeight: 'normal' },
          },
          medium: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '28',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'medium-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '28', letterSpacing: '0', lineHeight: 'normal' },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '24',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '24', letterSpacing: '0', lineHeight: 'normal' },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '20', letterSpacing: '0', lineHeight: 'normal' },
          },
        },
        body: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '700', fontSize: '18', letterSpacing: '0', lineHeight: '120%' },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '400', fontSize: '14', letterSpacing: '0', lineHeight: '120%' },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        caption: {
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        paragraph: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        link: {
          'link-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
        },
      },
    },
    medium: {
      brand: 'legacy',
      mode: 'light',
      breakpoint: 'medium',
      colors: {
        black: '#1F2635',
        'border.brand': '#1A3D32',
        'border.brand-alt': '#8EDED0',
        'border.disabled': '#28272514',
        'border.divider': '#2827251F',
        'border.error': '#BE171B',
        'border.focused': '#2B8176',
        'border.info': '#2C6CBF',
        'border.interactive': '#3A9488',
        'border.inverse.disabled': '#FDFDFC66',
        'border.inverse.divider': '#FDFDFC33',
        'border.inverse.interactive': '#64BAAF',
        'border.inverse.primary': '#FFFFFF',
        'border.inverse.secondary': '#FDFDFC66',
        'border.inverse.selected': '#64BAAF',
        'border.inverse.strong': '#FFFFFF',
        'border.primary': '#28272566',
        'border.secondary': '#28272529',
        'border.secondary-1.default': '#D2E4A8',
        'border.secondary-1.strong': '#344417',
        'border.secondary-1.subtle': '#F4F8E8',
        'border.secondary-2.default': '#F2D87A',
        'border.secondary-2.strong': '#6A4B17',
        'border.secondary-2.subtle': '#FDF8E8',
        'border.secondary-3.default': '#E39464',
        'border.secondary-3.strong': '#5C2314',
        'border.secondary-3.subtle': '#FDF0E8',
        'border.secondary-4.default': '#D97A73',
        'border.secondary-4.strong': '#521F1B',
        'border.secondary-4.subtle': '#FDE8EC',
        'border.secondary-5.default': '#8F6B97',
        'border.secondary-5.low': '#B8A4D0',
        'border.secondary-5.medium': '#64466C',
        'border.secondary-5.strong': '#3A2640',
        'border.secondary-5.subtle': '#F3EEF7',
        'border.selected': '#3A9488',
        'border.strong': '#1F2635',
        'border.success': '#5B9D13',
        'border.warning': '#BB8713',
        'component.button.bg.hover': '#FDFDFC33',
        'component.button.bg.inverted': '#FFFFFF',
        'component.button.bg.pressed': '#FDFDFC14',
        'component.button.bg.primary': '#1F2635',
        'component.button.bg.secondary': '#E8F8F4',
        'component.button.bg.tertiary': '#F5F3F0',
        'component.button.bg.transparent': '#28272599',
        'component.button.border.tertiary': '#1F2635',
        'component.button.icon.tertiary': '#1F2635',
        'component.button.label.tertiary': '#1F2635',
        'concept.ambassador.border': '#F5EA93',
        'concept.ambassador.icon': '#BB8713',
        'concept.ambassador.surface.default': '#D8AD1A',
        'concept.ambassador.surface.strong': '#6A4019',
        'concept.ambassador.surface.subtle': '#FCFBEA',
        'concept.ambassador.text': '#956213',
        'concept.exoneration.border': '#8EDED0',
        'concept.exoneration.icon': '#1F2635',
        'concept.exoneration.surface.default': '#3A9488',
        'concept.exoneration.surface.low': '#B8ECE0',
        'concept.exoneration.surface.medium': '#236B61',
        'concept.exoneration.surface.strong': '#1F2635',
        'concept.exoneration.surface.subtle': '#E8F8F4',
        'concept.exoneration.text': '#1F2635',
        'concept.pension.border': '#ADCDF7',
        'concept.pension.icon': '#2C6CBF',
        'concept.pension.surface.default': '#3383EB',
        'concept.pension.surface.strong': '#15253D',
        'concept.pension.surface.subtle': '#EBF3FE',
        'concept.pension.text-on-dark': '#EBF3FE',
        'concept.pension.text-on-light': '#255594',
        'concept.plan.free.icon-on-surface': '#1F2635',
        'concept.plan.free.surface.default': '#3383EB',
        'concept.plan.free.surface.low': '#ADCDF7',
        'concept.plan.free.surface.medium': '#255594',
        'concept.plan.free.surface.strong': '#15253D',
        'concept.plan.free.surface.subtle': '#EBF3FE',
        'concept.plan.free.text-on-surface': '#1F2635',
        'concept.plan.premium.accent': '#F7E9AB',
        'concept.plan.premium.border': '#CFC1E1',
        'concept.plan.premium.icon-on-surface': '#7A5882',
        'concept.plan.premium.surface.default': '#8F6B97',
        'concept.plan.premium.surface.low': '#CFC1E1',
        'concept.plan.premium.surface.medium': '#64466C',
        'concept.plan.premium.surface.strong': '#3A2640',
        'concept.plan.premium.surface.subtle': '#F3EEF7',
        'concept.plan.premium.text-on-surface': '#64466C',
        'concept.trust-club.border': '#FFDDDD',
        'concept.trust-club.icon': '#FFA9AB',
        'concept.trust-club.surface.default': '#FFA9AB',
        'concept.trust-club.surface.strong': '#3E2D30',
        'concept.trust-club.surface.subtle': '#FFF7F7',
        'concept.trust-club.text-on-dark': '#FFF7F7',
        'concept.trust-club.text-on-light': '#9F6B6E',
        'gradient.bottom-tab-bar-end': '#FEFEFDB2',
        'gradient.bottom-tab-bar-start': '#FEFEFD00',
        'gradient.primary': '#FFFFFF00',
        'icon.brand': '#1F2635',
        'icon.brand-alt': '#8EDED0',
        'icon.disabled': '#28272566',
        'icon.emphasized': '#2B8176',
        'icon.error': '#BE171B',
        'icon.info': '#2C6CBF',
        'icon.interactive': '#3A9488',
        'icon.inverse.disabled': '#FDFDFC99',
        'icon.inverse.interactive': '#64BAAF',
        'icon.inverse.on-selected': '#3A9488',
        'icon.inverse.primary': '#FFFFFF',
        'icon.inverse.secondary': '#FDFDFC',
        'icon.primary': '#1F2635',
        'icon.secondary': '#6B6861',
        'icon.secondary-1.default': '#88A750',
        'icon.secondary-1.low': '#D2E4A8',
        'icon.secondary-1.medium': '#5C7530',
        'icon.secondary-1.strong': '#344417',
        'icon.secondary-1.subtle': '#F4F8E8',
        'icon.secondary-2.default': '#EECA60',
        'icon.secondary-2.low': '#F7E9AB',
        'icon.secondary-2.medium': '#D4A03A',
        'icon.secondary-2.strong': '#6A4B17',
        'icon.secondary-2.subtle': '#FDF8E8',
        'icon.secondary-3.default': '#E39464',
        'icon.secondary-3.low': '#F8CAAA',
        'icon.secondary-3.medium': '#BE6539',
        'icon.secondary-3.strong': '#5C2314',
        'icon.secondary-3.subtle': '#FDF0E8',
        'icon.secondary-4.default': '#D97A73',
        'icon.secondary-4.low': '#F1ADB2',
        'icon.secondary-4.medium': '#9B4138',
        'icon.secondary-4.strong': '#521F1B',
        'icon.secondary-4.subtle': '#FDE8EC',
        'icon.secondary-5.default': '#8F6B97',
        'icon.secondary-5.low': '#B8A4D0',
        'icon.secondary-5.medium': '#64466C',
        'icon.secondary-5.strong': '#3A2640',
        'icon.secondary-5.subtle': '#F3EEF7',
        'icon.selected': '#3A9488',
        'icon.success': '#457714',
        'icon.tertiary': '#C6C3B9',
        'icon.warning': '#BB8713',
        page: '#FFFFFF',
        'shadow.inner': '#FDFDFC66',
        'shadow.lg': '#28272529',
        'shadow.md': '#2827251F',
        'shadow.sm': '#28272514',
        'shadow.xl': '#28272533',
        'shadow.xs': '#2827250A',
        'state-layer.hover': '#28272514',
        'state-layer.hover-alt': '#28272514',
        'state-layer.hover-brand': '#B8ECE033',
        'state-layer.hover-on-color': '#28272533',
        'state-layer.inverse.hover': '#FDFDFC14',
        'state-layer.inverse.hover-brand': '#B8ECE033',
        'state-layer.inverse.hover-on-color': '#FDFDFC33',
        'state-layer.inverse.press': '#FDFDFC29',
        'state-layer.inverse.press-brand': '#B8ECE066',
        'state-layer.inverse.press-on-color': '#28272566',
        'state-layer.press': '#28272529',
        'state-layer.press-alt': '#28272529',
        'state-layer.press-brand': '#B8ECE066',
        'state-layer.press-on-color': '#28272566',
        'surface.brand.bold': '#1F2635',
        'surface.brand.bold-alt': '#0E2720',
        'surface.brand.default': '#3A9488',
        'surface.brand.default-alt': '#3A9488',
        'surface.brand.secondary-1.default': '#88A750',
        'surface.brand.secondary-1.low': '#B8D47E',
        'surface.brand.secondary-1.medium': '#5C7530',
        'surface.brand.secondary-1.strong': '#344417',
        'surface.brand.secondary-1.subtle': '#E7F0CE',
        'surface.brand.secondary-1.translucent.default': '#D2E4A833',
        'surface.brand.secondary-1.translucent.low': '#D2E4A829',
        'surface.brand.secondary-1.translucent.medium': '#D2E4A866',
        'surface.brand.secondary-1.translucent.strong': '#D2E4A899',
        'surface.brand.secondary-1.translucent.subtle': '#D2E4A81F',
        'surface.brand.secondary-2.default': '#F2D87A',
        'surface.brand.secondary-2.low': '#F7E9AB',
        'surface.brand.secondary-2.medium': '#EBBB4D',
        'surface.brand.secondary-2.strong': '#6A4B17',
        'surface.brand.secondary-2.subtle': '#F9EECC',
        'surface.brand.secondary-2.translucent.default': '#F2D87A33',
        'surface.brand.secondary-2.translucent.low': '#F2D87A29',
        'surface.brand.secondary-2.translucent.medium': '#F2D87A66',
        'surface.brand.secondary-2.translucent.strong': '#F2D87A99',
        'surface.brand.secondary-2.translucent.subtle': '#F2D87A1F',
        'surface.brand.secondary-3.default': '#E39464',
        'surface.brand.secondary-3.low': '#F8CAAA',
        'surface.brand.secondary-3.medium': '#BE6539',
        'surface.brand.secondary-3.strong': '#5C2314',
        'surface.brand.secondary-3.subtle': '#FBDDD0',
        'surface.brand.secondary-3.translucent.default': '#F8CAAA33',
        'surface.brand.secondary-3.translucent.low': '#F8CAAA29',
        'surface.brand.secondary-3.translucent.medium': '#F8CAAA66',
        'surface.brand.secondary-3.translucent.strong': '#F8CAAA99',
        'surface.brand.secondary-3.translucent.subtle': '#F8CAAA1F',
        'surface.brand.secondary-4.default': '#D97A73',
        'surface.brand.secondary-4.low': '#F1ADB2',
        'surface.brand.secondary-4.medium': '#9B4138',
        'surface.brand.secondary-4.strong': '#521F1B',
        'surface.brand.secondary-4.subtle': '#F9D1D8',
        'surface.brand.secondary-4.translucent.default': '#F5C2CB33',
        'surface.brand.secondary-4.translucent.low': '#F5C2CB29',
        'surface.brand.secondary-4.translucent.medium': '#F5C2CB66',
        'surface.brand.secondary-4.translucent.strong': '#F5C2CB99',
        'surface.brand.secondary-4.translucent.subtle': '#F5C2CB1F',
        'surface.brand.secondary-5.default': '#8F6B97',
        'surface.brand.secondary-5.low': '#B8A4D0',
        'surface.brand.secondary-5.medium': '#64466C',
        'surface.brand.secondary-5.strong': '#3A2640',
        'surface.brand.secondary-5.subtle': '#E5DAEF',
        'surface.brand.secondary-5.translucent.default': '#CFC1E133',
        'surface.brand.secondary-5.translucent.low': '#CFC1E129',
        'surface.brand.secondary-5.translucent.medium': '#CFC1E166',
        'surface.brand.secondary-5.translucent.strong': '#CFC1E199',
        'surface.brand.secondary-5.translucent.subtle': '#CFC1E11F',
        'surface.brand.strong': '#1F2635',
        'surface.brand.strong-alt': '#1A3D32',
        'surface.brand.subtle': '#E8F8F4',
        'surface.brand.subtle-alt': '#E8F8F4',
        'surface.brand.translucent.bold': '#B8ECE066',
        'surface.brand.translucent.bold-alt': '#B8ECE066',
        'surface.brand.translucent.default': '#B8ECE033',
        'surface.brand.translucent.strong': '#B8ECE066',
        'surface.brand.translucent.strong-alt': '#B8ECE066',
        'surface.brand.translucent.subtle': '#B8ECE014',
        'surface.default': '#FFFFFF',
        'surface.disabled': '#2827251F',
        'surface.error.default': '#F53E42',
        'surface.error.low': '#FFA9AB',
        'surface.error.medium': '#BE171B',
        'surface.error.strong': '#470809',
        'surface.error.subtle': '#FFE1E2',
        'surface.error.translucent.default': '#F53E4266',
        'surface.error.translucent.strong': '#F53E4299',
        'surface.error.translucent.subtle': '#F53E4233',
        'surface.info.default': '#3383EB',
        'surface.info.low': '#85B5F3',
        'surface.info.medium': '#255594',
        'surface.info.strong': '#121A27',
        'surface.info.subtle': '#EBF3FE',
        'surface.info.translucent.default': '#3383EB66',
        'surface.info.translucent.strong': '#3383EB99',
        'surface.info.translucent.subtle': '#3383EB33',
        'surface.interactive': '#3A9488',
        'surface.inverse.default': '#1F2635',
        'surface.inverse.disabled': '#FDFDFC33',
        'surface.inverse.primary-neutral': '#9B988C',
        'surface.inverse.secondary-neutral': '#C6C3B9',
        'surface.inverse.selected': '#E8F8F4',
        'surface.inverse.selected-strong': '#FFFFFF',
        'surface.inverse.tertiary-neutral': '#EEECE7',
        'surface.overlay': '#28272566',
        'surface.primary': '#E8F8F4',
        'surface.primary-alt': '#E8F8F4',
        'surface.primary-neutral': '#F9F8F6',
        'surface.secondary': '#B8ECE0',
        'surface.secondary-alt': '#B4ECDF',
        'surface.secondary-neutral': '#F5F3F0',
        'surface.selected': '#E8F8F4',
        'surface.selected-strong': '#3A9488',
        'surface.strong-neutral': '#3E3B38',
        'surface.success.default': '#77C41E',
        'surface.success.low': '#B3EC6A',
        'surface.success.medium': '#457714',
        'surface.success.strong': '#182C07',
        'surface.success.subtle': '#E8FACD',
        'surface.success.translucent.default': '#77C41E66',
        'surface.success.translucent.strong': '#77C41E99',
        'surface.success.translucent.subtle': '#77C41E33',
        'surface.tertiary': '#8EDED0',
        'surface.tertiary-alt': '#8EDED0',
        'surface.tertiary-neutral': '#EEECE7',
        'surface.translucent.default': '#2827250A',
        'surface.translucent.disabled': '#2827251F',
        'surface.translucent.primary': '#B8ECE014',
        'surface.translucent.primary-alt': '#B8ECE014',
        'surface.translucent.primary-neutral': '#28272514',
        'surface.translucent.secondary': '#B8ECE029',
        'surface.translucent.secondary-alt': '#B8ECE029',
        'surface.translucent.secondary-neutral': '#28272529',
        'surface.translucent.selected': '#B8ECE029',
        'surface.translucent.strong-neutral': '#28272566',
        'surface.translucent.tertiary': '#B8ECE066',
        'surface.translucent.tertiary-alt': '#B8ECE033',
        'surface.translucent.tertiary-neutral': '#28272533',
        'surface.warning.default': '#D8AD1A',
        'surface.warning.low': '#EDD441',
        'surface.warning.medium': '#956213',
        'surface.warning.strong': '#3D220B',
        'surface.warning.subtle': '#F9F6C8',
        'surface.warning.translucent.default': '#D8AD1A66',
        'surface.warning.translucent.strong': '#D8AD1A99',
        'surface.warning.translucent.subtle': '#D8AD1A33',
        'text.brand': '#1F2635',
        'text.brand-alt': '#8EDED0',
        'text.disabled': '#28272566',
        'text.emphasized': '#2B8176',
        'text.error': '#BE171B',
        'text.info': '#2C6CBF',
        'text.interactive': '#3A9488',
        'text.inverse.disabled': '#FDFDFC66',
        'text.inverse.emphasized': '#B8ECE0',
        'text.inverse.interactive': '#64BAAF',
        'text.inverse.primary': '#FFFFFF',
        'text.inverse.secondary': '#FDFDFCCC',
        'text.primary': '#1F2635',
        'text.secondary': '#6B6861',
        'text.secondary-1.default': '#88A750',
        'text.secondary-1.low': '#B8D47E',
        'text.secondary-1.medium': '#5C7530',
        'text.secondary-1.strong': '#344417',
        'text.secondary-1.subtle': '#F4F8E8',
        'text.secondary-2.default': '#F2D87A',
        'text.secondary-2.low': '#F7E9AB',
        'text.secondary-2.medium': '#EBBB4D',
        'text.secondary-2.strong': '#6A4B17',
        'text.secondary-2.subtle': '#FDF8E8',
        'text.secondary-3.default': '#E39464',
        'text.secondary-3.low': '#F8CAAA',
        'text.secondary-3.medium': '#BE6539',
        'text.secondary-3.strong': '#5C2314',
        'text.secondary-3.subtle': '#FDF0E8',
        'text.secondary-4.default': '#D97A73',
        'text.secondary-4.low': '#F1ADB2',
        'text.secondary-4.medium': '#9B4138',
        'text.secondary-4.strong': '#521F1B',
        'text.secondary-4.subtle': '#FDE8EC',
        'text.secondary-5.default': '#8F6B97',
        'text.secondary-5.low': '#B8A4D0',
        'text.secondary-5.medium': '#64466C',
        'text.secondary-5.strong': '#3A2640',
        'text.secondary-5.subtle': '#F3EEF7',
        'text.selected': '#3A9488',
        'text.success': '#457714',
        'text.tertiary': '#C6C3B9',
        'text.warning': '#BB8713',
        white: '#FFFFFF',
        'white-label.footer.footer-bg': '#F5F3F0',
        'white-label.header.bg': '#EEECE7',
        'white-label.header.on-header': '#1F2635',
        'white-label.headerSubtext': '#FFFFFF',
        'white-label.highlight': '#FFFFFF',
        'white-label.highlightText': '#FFFFFF',
        'white-label.notificationLogoBackground': '#FFFFFF',
        'white-label.publish-button.bg.header-bar': '#1F2635',
        'white-label.publish-button.bg.mobile-bottom-tab-bar': '#1F2635',
        'white-label.publish-button.icon.header-bar': '#FFFFFF',
        'white-label.publish-button.icon.mobile-bottom-tab-bar': '#FFFFFF',
        'white-label.publish-button.label.primary': '#FFFFFF',
        'white-label.splash': '#B8ECE0',
        'white-label.theme.icon.on-brand-accent': '#FFFFFF',
        'white-label.theme.surface.accent': '#1F2635',
        'white-label.theme.surface.primary': '#EEECE7',
        'white-label.theme.text.on-brand-accent': '#FFFFFF',
      },
      responsive: {
        'border-width.bold': '4',
        'border-width.emphasized': '2',
        'border-width.standard': '1.5',
        'border-width.subtle': '1',
        'motion.distance.component-enter': '8',
        'motion.distance.feedback': '2',
        'motion.distance.overlay-enter': '16',
        'motion.distance.page-enter': '24',
        'motion.duration.component-transition': '[object Object]',
        'motion.duration.feedback': '[object Object]',
        'motion.duration.micro-transition': '[object Object]',
        'motion.duration.overlay-transition': '[object Object]',
        'motion.duration.page-transition': '[object Object]',
        'motion.duration.passive': '[object Object]',
        'motion.easing.continuous': '0,0,1,1',
        'motion.easing.emphasize': '0.05000000074505806,0.699999988079071,0.10000000149011612,1',
        'motion.easing.enter': '0,0,0,1',
        'motion.easing.exit': '0.4000000059604645,0,1,1',
        'motion.easing.move': '0.20000000298023224,0,0,1',
        'motion.scale.emphasize': '1.0199999809265137',
        'motion.scale.enter': '0.9599999785423279',
        'motion.scale.press': '0.9800000190734863',
        'motion.stagger.relaxed': '[object Object]',
        'motion.stagger.standard': '[object Object]',
        'motion.stagger.tight': '[object Object]',
        'radius.component.fields.input': '16',
        'radius.component.publish-button.button-radius': '8',
        'radius.full': '1000',
        'radius.lg': '16',
        'radius.md': '12',
        'radius.none': '0',
        'radius.sm': '8',
        'radius.xl': '24',
        'radius.xs': '4',
        'radius.xxl': '32',
        'radius.xxs': '2',
        'shadow.blur.lg': '24',
        'shadow.blur.md': '12',
        'shadow.blur.sm': '8',
        'shadow.blur.xl': '36',
        'shadow.blur.xs': '2',
        'shadow.offset-y.lg': '8',
        'shadow.offset-y.md': '4',
        'shadow.offset-y.sm': '2',
        'shadow.offset-y.xl': '16',
        'shadow.offset-y.xs': '1',
        'sizing.body.max-width': '1279',
        'sizing.body.min-width': '768',
        'sizing.component.button.height.large': '56',
        'sizing.component.button.height.large-icn-button': '48',
        'sizing.component.button.height.medium': '40',
        'sizing.component.button.height.small': '32',
        'sizing.component.header.max-width': '1279',
        'sizing.component.header.min-width': '768',
        'sizing.general.0': '0',
        'sizing.general.x0,25': '1',
        'sizing.general.x0,5': '2',
        'sizing.general.x1': '4',
        'sizing.general.x10': '40',
        'sizing.general.x100': '400',
        'sizing.general.x12': '48',
        'sizing.general.x120': '480',
        'sizing.general.x14': '56',
        'sizing.general.x140': '560',
        'sizing.general.x150': '600',
        'sizing.general.x16': '64',
        'sizing.general.x160': '640',
        'sizing.general.x18': '72',
        'sizing.general.x180': '720',
        'sizing.general.x2': '8',
        'sizing.general.x20': '80',
        'sizing.general.x200': '800',
        'sizing.general.x22': '88',
        'sizing.general.x24': '96',
        'sizing.general.x3': '12',
        'sizing.general.x30': '120',
        'sizing.general.x36': '144',
        'sizing.general.x4': '16',
        'sizing.general.x40': '160',
        'sizing.general.x5': '20',
        'sizing.general.x50': '200',
        'sizing.general.x6': '24',
        'sizing.general.x60': '240',
        'sizing.general.x7': '28',
        'sizing.general.x70': '280',
        'sizing.general.x8': '32',
        'sizing.general.x80': '320',
        'sizing.general.x90': '360',
        'sizing.icon.default': '24',
        'sizing.icon.lg': '32',
        'sizing.icon.s': '16',
        'sizing.icon.sm': '20',
        'sizing.icon.xl': '56',
        'sizing.icon.xs': '12',
        'spacing.general.0': '0',
        'spacing.general.x0,5': '2',
        'spacing.general.x1': '4',
        'spacing.general.x10': '40',
        'spacing.general.x12': '48',
        'spacing.general.x14': '56',
        'spacing.general.x16': '64',
        'spacing.general.x18': '72',
        'spacing.general.x2': '8',
        'spacing.general.x20': '80',
        'spacing.general.x22': '88',
        'spacing.general.x24': '96',
        'spacing.general.x3': '12',
        'spacing.general.x30': '120',
        'spacing.general.x36': '144',
        'spacing.general.x4': '16',
        'spacing.general.x5': '20',
        'spacing.general.x6': '24',
        'spacing.general.x7': '28',
        'spacing.general.x8': '32',
        'spacing.semantic.bottom-safe-zone': '36',
        'spacing.semantic.line-height-fix': '2',
        'spacing.semantic.page-margin': '32',
        'typography.font-size.body.base': '16',
        'typography.font-size.body.caption-base': '10',
        'typography.font-size.body.caption-large': '12',
        'typography.font-size.body.large': '18',
        'typography.font-size.body.small': '14',
        'typography.font-size.body.x-large': '20',
        'typography.font-size.body.x-small': '12',
        'typography.font-size.header.display-1': '48',
        'typography.font-size.header.display-2': '56',
        'typography.font-size.header.large': '40',
        'typography.font-size.header.medium': '32',
        'typography.font-size.header.small': '28',
        'typography.font-size.header.x-small': '24',
        'typography.font-size.link.link-base': '16',
        'typography.font-size.link.link-large': '20',
        'typography.font-size.link.link-small': '14',
        'typography.letter-spacing.body.base': '0',
        'typography.letter-spacing.body.caption': '0',
        'typography.letter-spacing.body.large': '0',
        'typography.letter-spacing.body.small': '0',
        'typography.letter-spacing.body.x-large': '0',
        'typography.letter-spacing.body.x-small': '0',
        'typography.letter-spacing.header.display-1': '0',
        'typography.letter-spacing.header.display-2': '0',
        'typography.letter-spacing.header.large': '0',
        'typography.letter-spacing.header.medium': '0',
        'typography.letter-spacing.header.small': '0',
        'typography.letter-spacing.header.x-small': '0',
      },
      styles: {
        header: {
          'display-2': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '56',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'display-1': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '48',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '40',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '40', letterSpacing: '0', lineHeight: 'normal' },
          },
          medium: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '32',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'medium-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '32', letterSpacing: '0', lineHeight: 'normal' },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '28',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '28', letterSpacing: '0', lineHeight: 'normal' },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '24',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '24', letterSpacing: '0', lineHeight: 'normal' },
          },
        },
        body: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '700', fontSize: '18', letterSpacing: '0', lineHeight: '120%' },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '400', fontSize: '14', letterSpacing: '0', lineHeight: '120%' },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        caption: {
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        paragraph: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        link: {
          'link-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
        },
      },
    },
    large: {
      brand: 'legacy',
      mode: 'light',
      breakpoint: 'large',
      colors: {
        black: '#1F2635',
        'border.brand': '#1A3D32',
        'border.brand-alt': '#8EDED0',
        'border.disabled': '#28272514',
        'border.divider': '#2827251F',
        'border.error': '#BE171B',
        'border.focused': '#2B8176',
        'border.info': '#2C6CBF',
        'border.interactive': '#3A9488',
        'border.inverse.disabled': '#FDFDFC66',
        'border.inverse.divider': '#FDFDFC33',
        'border.inverse.interactive': '#64BAAF',
        'border.inverse.primary': '#FFFFFF',
        'border.inverse.secondary': '#FDFDFC66',
        'border.inverse.selected': '#64BAAF',
        'border.inverse.strong': '#FFFFFF',
        'border.primary': '#28272566',
        'border.secondary': '#28272529',
        'border.secondary-1.default': '#D2E4A8',
        'border.secondary-1.strong': '#344417',
        'border.secondary-1.subtle': '#F4F8E8',
        'border.secondary-2.default': '#F2D87A',
        'border.secondary-2.strong': '#6A4B17',
        'border.secondary-2.subtle': '#FDF8E8',
        'border.secondary-3.default': '#E39464',
        'border.secondary-3.strong': '#5C2314',
        'border.secondary-3.subtle': '#FDF0E8',
        'border.secondary-4.default': '#D97A73',
        'border.secondary-4.strong': '#521F1B',
        'border.secondary-4.subtle': '#FDE8EC',
        'border.secondary-5.default': '#8F6B97',
        'border.secondary-5.low': '#B8A4D0',
        'border.secondary-5.medium': '#64466C',
        'border.secondary-5.strong': '#3A2640',
        'border.secondary-5.subtle': '#F3EEF7',
        'border.selected': '#3A9488',
        'border.strong': '#1F2635',
        'border.success': '#5B9D13',
        'border.warning': '#BB8713',
        'component.button.bg.hover': '#FDFDFC33',
        'component.button.bg.inverted': '#FFFFFF',
        'component.button.bg.pressed': '#FDFDFC14',
        'component.button.bg.primary': '#1F2635',
        'component.button.bg.secondary': '#E8F8F4',
        'component.button.bg.tertiary': '#F5F3F0',
        'component.button.bg.transparent': '#28272599',
        'component.button.border.tertiary': '#1F2635',
        'component.button.icon.tertiary': '#1F2635',
        'component.button.label.tertiary': '#1F2635',
        'concept.ambassador.border': '#F5EA93',
        'concept.ambassador.icon': '#BB8713',
        'concept.ambassador.surface.default': '#D8AD1A',
        'concept.ambassador.surface.strong': '#6A4019',
        'concept.ambassador.surface.subtle': '#FCFBEA',
        'concept.ambassador.text': '#956213',
        'concept.exoneration.border': '#8EDED0',
        'concept.exoneration.icon': '#1F2635',
        'concept.exoneration.surface.default': '#3A9488',
        'concept.exoneration.surface.low': '#B8ECE0',
        'concept.exoneration.surface.medium': '#236B61',
        'concept.exoneration.surface.strong': '#1F2635',
        'concept.exoneration.surface.subtle': '#E8F8F4',
        'concept.exoneration.text': '#1F2635',
        'concept.pension.border': '#ADCDF7',
        'concept.pension.icon': '#2C6CBF',
        'concept.pension.surface.default': '#3383EB',
        'concept.pension.surface.strong': '#15253D',
        'concept.pension.surface.subtle': '#EBF3FE',
        'concept.pension.text-on-dark': '#EBF3FE',
        'concept.pension.text-on-light': '#255594',
        'concept.plan.free.icon-on-surface': '#1F2635',
        'concept.plan.free.surface.default': '#3383EB',
        'concept.plan.free.surface.low': '#ADCDF7',
        'concept.plan.free.surface.medium': '#255594',
        'concept.plan.free.surface.strong': '#15253D',
        'concept.plan.free.surface.subtle': '#EBF3FE',
        'concept.plan.free.text-on-surface': '#1F2635',
        'concept.plan.premium.accent': '#F7E9AB',
        'concept.plan.premium.border': '#CFC1E1',
        'concept.plan.premium.icon-on-surface': '#7A5882',
        'concept.plan.premium.surface.default': '#8F6B97',
        'concept.plan.premium.surface.low': '#CFC1E1',
        'concept.plan.premium.surface.medium': '#64466C',
        'concept.plan.premium.surface.strong': '#3A2640',
        'concept.plan.premium.surface.subtle': '#F3EEF7',
        'concept.plan.premium.text-on-surface': '#64466C',
        'concept.trust-club.border': '#FFDDDD',
        'concept.trust-club.icon': '#FFA9AB',
        'concept.trust-club.surface.default': '#FFA9AB',
        'concept.trust-club.surface.strong': '#3E2D30',
        'concept.trust-club.surface.subtle': '#FFF7F7',
        'concept.trust-club.text-on-dark': '#FFF7F7',
        'concept.trust-club.text-on-light': '#9F6B6E',
        'gradient.bottom-tab-bar-end': '#FEFEFDB2',
        'gradient.bottom-tab-bar-start': '#FEFEFD00',
        'gradient.primary': '#FFFFFF00',
        'icon.brand': '#1F2635',
        'icon.brand-alt': '#8EDED0',
        'icon.disabled': '#28272566',
        'icon.emphasized': '#2B8176',
        'icon.error': '#BE171B',
        'icon.info': '#2C6CBF',
        'icon.interactive': '#3A9488',
        'icon.inverse.disabled': '#FDFDFC99',
        'icon.inverse.interactive': '#64BAAF',
        'icon.inverse.on-selected': '#3A9488',
        'icon.inverse.primary': '#FFFFFF',
        'icon.inverse.secondary': '#FDFDFC',
        'icon.primary': '#1F2635',
        'icon.secondary': '#6B6861',
        'icon.secondary-1.default': '#88A750',
        'icon.secondary-1.low': '#D2E4A8',
        'icon.secondary-1.medium': '#5C7530',
        'icon.secondary-1.strong': '#344417',
        'icon.secondary-1.subtle': '#F4F8E8',
        'icon.secondary-2.default': '#EECA60',
        'icon.secondary-2.low': '#F7E9AB',
        'icon.secondary-2.medium': '#D4A03A',
        'icon.secondary-2.strong': '#6A4B17',
        'icon.secondary-2.subtle': '#FDF8E8',
        'icon.secondary-3.default': '#E39464',
        'icon.secondary-3.low': '#F8CAAA',
        'icon.secondary-3.medium': '#BE6539',
        'icon.secondary-3.strong': '#5C2314',
        'icon.secondary-3.subtle': '#FDF0E8',
        'icon.secondary-4.default': '#D97A73',
        'icon.secondary-4.low': '#F1ADB2',
        'icon.secondary-4.medium': '#9B4138',
        'icon.secondary-4.strong': '#521F1B',
        'icon.secondary-4.subtle': '#FDE8EC',
        'icon.secondary-5.default': '#8F6B97',
        'icon.secondary-5.low': '#B8A4D0',
        'icon.secondary-5.medium': '#64466C',
        'icon.secondary-5.strong': '#3A2640',
        'icon.secondary-5.subtle': '#F3EEF7',
        'icon.selected': '#3A9488',
        'icon.success': '#457714',
        'icon.tertiary': '#C6C3B9',
        'icon.warning': '#BB8713',
        page: '#FFFFFF',
        'shadow.inner': '#FDFDFC66',
        'shadow.lg': '#28272529',
        'shadow.md': '#2827251F',
        'shadow.sm': '#28272514',
        'shadow.xl': '#28272533',
        'shadow.xs': '#2827250A',
        'state-layer.hover': '#28272514',
        'state-layer.hover-alt': '#28272514',
        'state-layer.hover-brand': '#B8ECE033',
        'state-layer.hover-on-color': '#28272533',
        'state-layer.inverse.hover': '#FDFDFC14',
        'state-layer.inverse.hover-brand': '#B8ECE033',
        'state-layer.inverse.hover-on-color': '#FDFDFC33',
        'state-layer.inverse.press': '#FDFDFC29',
        'state-layer.inverse.press-brand': '#B8ECE066',
        'state-layer.inverse.press-on-color': '#28272566',
        'state-layer.press': '#28272529',
        'state-layer.press-alt': '#28272529',
        'state-layer.press-brand': '#B8ECE066',
        'state-layer.press-on-color': '#28272566',
        'surface.brand.bold': '#1F2635',
        'surface.brand.bold-alt': '#0E2720',
        'surface.brand.default': '#3A9488',
        'surface.brand.default-alt': '#3A9488',
        'surface.brand.secondary-1.default': '#88A750',
        'surface.brand.secondary-1.low': '#B8D47E',
        'surface.brand.secondary-1.medium': '#5C7530',
        'surface.brand.secondary-1.strong': '#344417',
        'surface.brand.secondary-1.subtle': '#E7F0CE',
        'surface.brand.secondary-1.translucent.default': '#D2E4A833',
        'surface.brand.secondary-1.translucent.low': '#D2E4A829',
        'surface.brand.secondary-1.translucent.medium': '#D2E4A866',
        'surface.brand.secondary-1.translucent.strong': '#D2E4A899',
        'surface.brand.secondary-1.translucent.subtle': '#D2E4A81F',
        'surface.brand.secondary-2.default': '#F2D87A',
        'surface.brand.secondary-2.low': '#F7E9AB',
        'surface.brand.secondary-2.medium': '#EBBB4D',
        'surface.brand.secondary-2.strong': '#6A4B17',
        'surface.brand.secondary-2.subtle': '#F9EECC',
        'surface.brand.secondary-2.translucent.default': '#F2D87A33',
        'surface.brand.secondary-2.translucent.low': '#F2D87A29',
        'surface.brand.secondary-2.translucent.medium': '#F2D87A66',
        'surface.brand.secondary-2.translucent.strong': '#F2D87A99',
        'surface.brand.secondary-2.translucent.subtle': '#F2D87A1F',
        'surface.brand.secondary-3.default': '#E39464',
        'surface.brand.secondary-3.low': '#F8CAAA',
        'surface.brand.secondary-3.medium': '#BE6539',
        'surface.brand.secondary-3.strong': '#5C2314',
        'surface.brand.secondary-3.subtle': '#FBDDD0',
        'surface.brand.secondary-3.translucent.default': '#F8CAAA33',
        'surface.brand.secondary-3.translucent.low': '#F8CAAA29',
        'surface.brand.secondary-3.translucent.medium': '#F8CAAA66',
        'surface.brand.secondary-3.translucent.strong': '#F8CAAA99',
        'surface.brand.secondary-3.translucent.subtle': '#F8CAAA1F',
        'surface.brand.secondary-4.default': '#D97A73',
        'surface.brand.secondary-4.low': '#F1ADB2',
        'surface.brand.secondary-4.medium': '#9B4138',
        'surface.brand.secondary-4.strong': '#521F1B',
        'surface.brand.secondary-4.subtle': '#F9D1D8',
        'surface.brand.secondary-4.translucent.default': '#F5C2CB33',
        'surface.brand.secondary-4.translucent.low': '#F5C2CB29',
        'surface.brand.secondary-4.translucent.medium': '#F5C2CB66',
        'surface.brand.secondary-4.translucent.strong': '#F5C2CB99',
        'surface.brand.secondary-4.translucent.subtle': '#F5C2CB1F',
        'surface.brand.secondary-5.default': '#8F6B97',
        'surface.brand.secondary-5.low': '#B8A4D0',
        'surface.brand.secondary-5.medium': '#64466C',
        'surface.brand.secondary-5.strong': '#3A2640',
        'surface.brand.secondary-5.subtle': '#E5DAEF',
        'surface.brand.secondary-5.translucent.default': '#CFC1E133',
        'surface.brand.secondary-5.translucent.low': '#CFC1E129',
        'surface.brand.secondary-5.translucent.medium': '#CFC1E166',
        'surface.brand.secondary-5.translucent.strong': '#CFC1E199',
        'surface.brand.secondary-5.translucent.subtle': '#CFC1E11F',
        'surface.brand.strong': '#1F2635',
        'surface.brand.strong-alt': '#1A3D32',
        'surface.brand.subtle': '#E8F8F4',
        'surface.brand.subtle-alt': '#E8F8F4',
        'surface.brand.translucent.bold': '#B8ECE066',
        'surface.brand.translucent.bold-alt': '#B8ECE066',
        'surface.brand.translucent.default': '#B8ECE033',
        'surface.brand.translucent.strong': '#B8ECE066',
        'surface.brand.translucent.strong-alt': '#B8ECE066',
        'surface.brand.translucent.subtle': '#B8ECE014',
        'surface.default': '#FFFFFF',
        'surface.disabled': '#2827251F',
        'surface.error.default': '#F53E42',
        'surface.error.low': '#FFA9AB',
        'surface.error.medium': '#BE171B',
        'surface.error.strong': '#470809',
        'surface.error.subtle': '#FFE1E2',
        'surface.error.translucent.default': '#F53E4266',
        'surface.error.translucent.strong': '#F53E4299',
        'surface.error.translucent.subtle': '#F53E4233',
        'surface.info.default': '#3383EB',
        'surface.info.low': '#85B5F3',
        'surface.info.medium': '#255594',
        'surface.info.strong': '#121A27',
        'surface.info.subtle': '#EBF3FE',
        'surface.info.translucent.default': '#3383EB66',
        'surface.info.translucent.strong': '#3383EB99',
        'surface.info.translucent.subtle': '#3383EB33',
        'surface.interactive': '#3A9488',
        'surface.inverse.default': '#1F2635',
        'surface.inverse.disabled': '#FDFDFC33',
        'surface.inverse.primary-neutral': '#9B988C',
        'surface.inverse.secondary-neutral': '#C6C3B9',
        'surface.inverse.selected': '#E8F8F4',
        'surface.inverse.selected-strong': '#FFFFFF',
        'surface.inverse.tertiary-neutral': '#EEECE7',
        'surface.overlay': '#28272566',
        'surface.primary': '#E8F8F4',
        'surface.primary-alt': '#E8F8F4',
        'surface.primary-neutral': '#F9F8F6',
        'surface.secondary': '#B8ECE0',
        'surface.secondary-alt': '#B4ECDF',
        'surface.secondary-neutral': '#F5F3F0',
        'surface.selected': '#E8F8F4',
        'surface.selected-strong': '#3A9488',
        'surface.strong-neutral': '#3E3B38',
        'surface.success.default': '#77C41E',
        'surface.success.low': '#B3EC6A',
        'surface.success.medium': '#457714',
        'surface.success.strong': '#182C07',
        'surface.success.subtle': '#E8FACD',
        'surface.success.translucent.default': '#77C41E66',
        'surface.success.translucent.strong': '#77C41E99',
        'surface.success.translucent.subtle': '#77C41E33',
        'surface.tertiary': '#8EDED0',
        'surface.tertiary-alt': '#8EDED0',
        'surface.tertiary-neutral': '#EEECE7',
        'surface.translucent.default': '#2827250A',
        'surface.translucent.disabled': '#2827251F',
        'surface.translucent.primary': '#B8ECE014',
        'surface.translucent.primary-alt': '#B8ECE014',
        'surface.translucent.primary-neutral': '#28272514',
        'surface.translucent.secondary': '#B8ECE029',
        'surface.translucent.secondary-alt': '#B8ECE029',
        'surface.translucent.secondary-neutral': '#28272529',
        'surface.translucent.selected': '#B8ECE029',
        'surface.translucent.strong-neutral': '#28272566',
        'surface.translucent.tertiary': '#B8ECE066',
        'surface.translucent.tertiary-alt': '#B8ECE033',
        'surface.translucent.tertiary-neutral': '#28272533',
        'surface.warning.default': '#D8AD1A',
        'surface.warning.low': '#EDD441',
        'surface.warning.medium': '#956213',
        'surface.warning.strong': '#3D220B',
        'surface.warning.subtle': '#F9F6C8',
        'surface.warning.translucent.default': '#D8AD1A66',
        'surface.warning.translucent.strong': '#D8AD1A99',
        'surface.warning.translucent.subtle': '#D8AD1A33',
        'text.brand': '#1F2635',
        'text.brand-alt': '#8EDED0',
        'text.disabled': '#28272566',
        'text.emphasized': '#2B8176',
        'text.error': '#BE171B',
        'text.info': '#2C6CBF',
        'text.interactive': '#3A9488',
        'text.inverse.disabled': '#FDFDFC66',
        'text.inverse.emphasized': '#B8ECE0',
        'text.inverse.interactive': '#64BAAF',
        'text.inverse.primary': '#FFFFFF',
        'text.inverse.secondary': '#FDFDFCCC',
        'text.primary': '#1F2635',
        'text.secondary': '#6B6861',
        'text.secondary-1.default': '#88A750',
        'text.secondary-1.low': '#B8D47E',
        'text.secondary-1.medium': '#5C7530',
        'text.secondary-1.strong': '#344417',
        'text.secondary-1.subtle': '#F4F8E8',
        'text.secondary-2.default': '#F2D87A',
        'text.secondary-2.low': '#F7E9AB',
        'text.secondary-2.medium': '#EBBB4D',
        'text.secondary-2.strong': '#6A4B17',
        'text.secondary-2.subtle': '#FDF8E8',
        'text.secondary-3.default': '#E39464',
        'text.secondary-3.low': '#F8CAAA',
        'text.secondary-3.medium': '#BE6539',
        'text.secondary-3.strong': '#5C2314',
        'text.secondary-3.subtle': '#FDF0E8',
        'text.secondary-4.default': '#D97A73',
        'text.secondary-4.low': '#F1ADB2',
        'text.secondary-4.medium': '#9B4138',
        'text.secondary-4.strong': '#521F1B',
        'text.secondary-4.subtle': '#FDE8EC',
        'text.secondary-5.default': '#8F6B97',
        'text.secondary-5.low': '#B8A4D0',
        'text.secondary-5.medium': '#64466C',
        'text.secondary-5.strong': '#3A2640',
        'text.secondary-5.subtle': '#F3EEF7',
        'text.selected': '#3A9488',
        'text.success': '#457714',
        'text.tertiary': '#C6C3B9',
        'text.warning': '#BB8713',
        white: '#FFFFFF',
        'white-label.footer.footer-bg': '#F5F3F0',
        'white-label.header.bg': '#EEECE7',
        'white-label.header.on-header': '#1F2635',
        'white-label.headerSubtext': '#FFFFFF',
        'white-label.highlight': '#FFFFFF',
        'white-label.highlightText': '#FFFFFF',
        'white-label.notificationLogoBackground': '#FFFFFF',
        'white-label.publish-button.bg.header-bar': '#1F2635',
        'white-label.publish-button.bg.mobile-bottom-tab-bar': '#1F2635',
        'white-label.publish-button.icon.header-bar': '#FFFFFF',
        'white-label.publish-button.icon.mobile-bottom-tab-bar': '#FFFFFF',
        'white-label.publish-button.label.primary': '#FFFFFF',
        'white-label.splash': '#B8ECE0',
        'white-label.theme.icon.on-brand-accent': '#FFFFFF',
        'white-label.theme.surface.accent': '#1F2635',
        'white-label.theme.surface.primary': '#EEECE7',
        'white-label.theme.text.on-brand-accent': '#FFFFFF',
      },
      responsive: {
        'border-width.bold': '4',
        'border-width.emphasized': '2',
        'border-width.standard': '1.5',
        'border-width.subtle': '1',
        'motion.distance.component-enter': '12',
        'motion.distance.feedback': '4',
        'motion.distance.overlay-enter': '24',
        'motion.distance.page-enter': '32',
        'motion.duration.component-transition': '[object Object]',
        'motion.duration.feedback': '[object Object]',
        'motion.duration.micro-transition': '[object Object]',
        'motion.duration.overlay-transition': '[object Object]',
        'motion.duration.page-transition': '[object Object]',
        'motion.duration.passive': '[object Object]',
        'motion.easing.continuous': '0,0,1,1',
        'motion.easing.emphasize': '0.05000000074505806,0.699999988079071,0.10000000149011612,1',
        'motion.easing.enter': '0,0,0,1',
        'motion.easing.exit': '0.4000000059604645,0,1,1',
        'motion.easing.move': '0.20000000298023224,0,0,1',
        'motion.scale.emphasize': '1.0199999809265137',
        'motion.scale.enter': '0.9599999785423279',
        'motion.scale.press': '0.9800000190734863',
        'motion.stagger.relaxed': '[object Object]',
        'motion.stagger.standard': '[object Object]',
        'motion.stagger.tight': '[object Object]',
        'radius.component.fields.input': '16',
        'radius.component.publish-button.button-radius': '8',
        'radius.full': '1000',
        'radius.lg': '16',
        'radius.md': '12',
        'radius.none': '0',
        'radius.sm': '8',
        'radius.xl': '24',
        'radius.xs': '4',
        'radius.xxl': '32',
        'radius.xxs': '2',
        'shadow.blur.lg': '32',
        'shadow.blur.md': '16',
        'shadow.blur.sm': '8',
        'shadow.blur.xl': '48',
        'shadow.blur.xs': '4',
        'shadow.offset-y.lg': '8',
        'shadow.offset-y.md': '4',
        'shadow.offset-y.sm': '2',
        'shadow.offset-y.xl': '16',
        'shadow.offset-y.xs': '1',
        'sizing.body.max-width': '1440',
        'sizing.body.min-width': '1280',
        'sizing.component.button.height.large': '56',
        'sizing.component.button.height.large-icn-button': '48',
        'sizing.component.button.height.medium': '40',
        'sizing.component.button.height.small': '32',
        'sizing.component.header.max-width': '1920',
        'sizing.component.header.min-width': '1280',
        'sizing.general.0': '0',
        'sizing.general.x0,25': '1',
        'sizing.general.x0,5': '2',
        'sizing.general.x1': '4',
        'sizing.general.x10': '40',
        'sizing.general.x100': '400',
        'sizing.general.x12': '48',
        'sizing.general.x120': '480',
        'sizing.general.x14': '56',
        'sizing.general.x140': '560',
        'sizing.general.x150': '600',
        'sizing.general.x16': '64',
        'sizing.general.x160': '640',
        'sizing.general.x18': '72',
        'sizing.general.x180': '720',
        'sizing.general.x2': '8',
        'sizing.general.x20': '80',
        'sizing.general.x200': '800',
        'sizing.general.x22': '88',
        'sizing.general.x24': '96',
        'sizing.general.x3': '12',
        'sizing.general.x30': '120',
        'sizing.general.x36': '144',
        'sizing.general.x4': '16',
        'sizing.general.x40': '160',
        'sizing.general.x5': '20',
        'sizing.general.x50': '200',
        'sizing.general.x6': '24',
        'sizing.general.x60': '240',
        'sizing.general.x7': '28',
        'sizing.general.x70': '280',
        'sizing.general.x8': '32',
        'sizing.general.x80': '320',
        'sizing.general.x90': '360',
        'sizing.icon.default': '24',
        'sizing.icon.lg': '32',
        'sizing.icon.s': '16',
        'sizing.icon.sm': '20',
        'sizing.icon.xl': '56',
        'sizing.icon.xs': '12',
        'spacing.general.0': '0',
        'spacing.general.x0,5': '2',
        'spacing.general.x1': '4',
        'spacing.general.x10': '40',
        'spacing.general.x12': '48',
        'spacing.general.x14': '56',
        'spacing.general.x16': '64',
        'spacing.general.x18': '72',
        'spacing.general.x2': '8',
        'spacing.general.x20': '80',
        'spacing.general.x22': '88',
        'spacing.general.x24': '96',
        'spacing.general.x3': '12',
        'spacing.general.x30': '120',
        'spacing.general.x36': '144',
        'spacing.general.x4': '16',
        'spacing.general.x5': '20',
        'spacing.general.x6': '24',
        'spacing.general.x7': '28',
        'spacing.general.x8': '32',
        'spacing.semantic.bottom-safe-zone': '36',
        'spacing.semantic.line-height-fix': '2',
        'spacing.semantic.page-margin': '48',
        'typography.font-size.body.base': '16',
        'typography.font-size.body.caption-base': '10',
        'typography.font-size.body.caption-large': '12',
        'typography.font-size.body.large': '18',
        'typography.font-size.body.small': '14',
        'typography.font-size.body.x-large': '20',
        'typography.font-size.body.x-small': '12',
        'typography.font-size.header.display-1': '56',
        'typography.font-size.header.display-2': '64',
        'typography.font-size.header.large': '48',
        'typography.font-size.header.medium': '40',
        'typography.font-size.header.small': '36',
        'typography.font-size.header.x-small': '32',
        'typography.font-size.link.link-base': '16',
        'typography.font-size.link.link-large': '20',
        'typography.font-size.link.link-small': '14',
        'typography.letter-spacing.body.base': '0',
        'typography.letter-spacing.body.caption': '0',
        'typography.letter-spacing.body.large': '0',
        'typography.letter-spacing.body.small': '0',
        'typography.letter-spacing.body.x-large': '0',
        'typography.letter-spacing.body.x-small': '0',
        'typography.letter-spacing.header.display-1': '0',
        'typography.letter-spacing.header.display-2': '0',
        'typography.letter-spacing.header.large': '0',
        'typography.letter-spacing.header.medium': '0',
        'typography.letter-spacing.header.small': '0',
        'typography.letter-spacing.header.x-small': '0',
      },
      styles: {
        header: {
          'display-2': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '64',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'display-1': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '56',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '48',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '48', letterSpacing: '0', lineHeight: 'normal' },
          },
          medium: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '40',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'medium-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '40', letterSpacing: '0', lineHeight: 'normal' },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '36',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '36', letterSpacing: '0', lineHeight: 'normal' },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '32',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '32', letterSpacing: '0', lineHeight: 'normal' },
          },
        },
        body: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '700', fontSize: '18', letterSpacing: '0', lineHeight: '120%' },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '400', fontSize: '14', letterSpacing: '0', lineHeight: '120%' },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        caption: {
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        paragraph: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        link: {
          'link-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
        },
      },
    },
  },
  dark: {
    small: {
      brand: 'legacy',
      mode: 'dark',
      breakpoint: 'small',
      colors: {
        black: '#1F2635',
        'border.brand': '#8EDED0',
        'border.brand-alt': '#1A3D32',
        'border.disabled': '#28272529',
        'border.divider': '#FDFDFC33',
        'border.error': '#FD6C6F',
        'border.focused': '#4DA89C',
        'border.info': '#5C9CEF',
        'border.interactive': '#4DA89C',
        'border.inverse.disabled': '#28272566',
        'border.inverse.divider': '#2827251F',
        'border.inverse.interactive': '#3A9488',
        'border.inverse.primary': '#28272566',
        'border.inverse.secondary': '#28272529',
        'border.inverse.selected': '#236B61',
        'border.inverse.strong': '#1F2635',
        'border.primary': '#FDFDFC66',
        'border.secondary': '#FDFDFC29',
        'border.secondary-1.default': '#A0C462',
        'border.secondary-1.strong': '#F4F8E8',
        'border.secondary-1.subtle': '#5C7530',
        'border.secondary-2.default': '#EECA60',
        'border.secondary-2.strong': '#FDF8E8',
        'border.secondary-2.subtle': '#B5832C',
        'border.secondary-3.default': '#E39464',
        'border.secondary-3.strong': '#FDF0E8',
        'border.secondary-3.subtle': '#9E4C2A',
        'border.secondary-4.default': '#EE9F99',
        'border.secondary-4.strong': '#FDE8EC',
        'border.secondary-4.subtle': '#9B4138',
        'border.secondary-5.default': '#A38ABF',
        'border.secondary-5.low': '#64466C',
        'border.secondary-5.medium': '#CFC1E1',
        'border.secondary-5.strong': '#F3EEF7',
        'border.secondary-5.subtle': '#3A2640',
        'border.selected': '#236B61',
        'border.strong': '#FFFFFF',
        'border.success': '#96DF3C',
        'border.warning': '#E8C427',
        'component.button.bg.hover': '#28272533',
        'component.button.bg.inverted': '#1F2635',
        'component.button.bg.pressed': '#28272599',
        'component.button.bg.primary': '#FFFFFF',
        'component.button.bg.secondary': '#8EDED0',
        'component.button.bg.tertiary': '#3E3B38',
        'component.button.bg.transparent': '#FDFDFC66',
        'component.button.border.tertiary': '#FFFFFF',
        'component.button.icon.tertiary': '#FFFFFF',
        'component.button.label.tertiary': '#FFFFFF',
        'concept.ambassador.border': '#7C4D17',
        'concept.ambassador.icon': '#E8C427',
        'concept.ambassador.surface.default': '#E8C427',
        'concept.ambassador.surface.strong': '#F9F6C8',
        'concept.ambassador.surface.subtle': '#3D220B',
        'concept.ambassador.text': '#EDD441',
        'concept.exoneration.border': '#9D3D0F',
        'concept.exoneration.icon': '#FFAD54',
        'concept.exoneration.surface.default': '#4DA89C',
        'concept.exoneration.surface.low': '#B8ECE0',
        'concept.exoneration.surface.medium': '#8EDED0',
        'concept.exoneration.surface.strong': '#B8ECE0',
        'concept.exoneration.surface.subtle': '#1F2635',
        'concept.exoneration.text': '#FFC471',
        'concept.pension.border': '#3A5F15',
        'concept.pension.icon': '#96DF3C',
        'concept.pension.surface.default': '#5C9CEF',
        'concept.pension.surface.strong': '#D6E6FB',
        'concept.pension.surface.subtle': '#121A27',
        'concept.pension.text-on-dark': '#B3EC6A',
        'concept.pension.text-on-light': '#B3EC6A',
        'concept.plan.free.icon-on-surface': '#FFFFFF',
        'concept.plan.free.surface.default': '#5C9CEF',
        'concept.plan.free.surface.low': '#1C3C68',
        'concept.plan.free.surface.medium': '#ADCDF7',
        'concept.plan.free.surface.strong': '#D6E6FB',
        'concept.plan.free.surface.subtle': '#121A27',
        'concept.plan.free.text-on-surface': '#FFFFFF',
        'concept.plan.premium.accent': '#F7E9AB',
        'concept.plan.premium.border': '#4F3556',
        'concept.plan.premium.icon-on-surface': '#A38ABF',
        'concept.plan.premium.surface.default': '#A38ABF',
        'concept.plan.premium.surface.low': '#4F3556',
        'concept.plan.premium.surface.medium': '#CFC1E1',
        'concept.plan.premium.surface.strong': '#E5DAEF',
        'concept.plan.premium.surface.subtle': '#231728',
        'concept.plan.premium.text-on-surface': '#B8A4D0',
        'concept.trust-club.border': '#6E4C4E',
        'concept.trust-club.icon': '#FFBABC',
        'concept.trust-club.surface.default': '#FFBABC',
        'concept.trust-club.surface.strong': '#FFEEEE',
        'concept.trust-club.surface.subtle': '#261E20',
        'concept.trust-club.text-on-dark': '#FFCBCD',
        'concept.trust-club.text-on-light': '#FFCBCD',
        'gradient.bottom-tab-bar-end': '#161616E5',
        'gradient.bottom-tab-bar-start': '#16161600',
        'gradient.primary': '#16161600',
        'icon.brand': '#8EDED0',
        'icon.brand-alt': '#1F2635',
        'icon.disabled': '#FDFDFC66',
        'icon.emphasized': '#4DA89C',
        'icon.error': '#FD6C6F',
        'icon.info': '#85B5F3',
        'icon.interactive': '#4DA89C',
        'icon.inverse.disabled': '#28272566',
        'icon.inverse.interactive': '#3A9488',
        'icon.inverse.on-selected': '#4DA89C',
        'icon.inverse.primary': '#1F2635',
        'icon.inverse.secondary': '#6B6861',
        'icon.primary': '#FFFFFF',
        'icon.secondary': '#C6C3B9',
        'icon.secondary-1.default': '#A0C462',
        'icon.secondary-1.low': '#5C7530',
        'icon.secondary-1.medium': '#D2E4A8',
        'icon.secondary-1.strong': '#F4F8E8',
        'icon.secondary-1.subtle': '#344417',
        'icon.secondary-2.default': '#EECA60',
        'icon.secondary-2.low': '#B5832C',
        'icon.secondary-2.medium': '#F7E9AB',
        'icon.secondary-2.strong': '#FDF8E8',
        'icon.secondary-2.subtle': '#6A4B17',
        'icon.secondary-3.default': '#E39464',
        'icon.secondary-3.low': '#9E4C2A',
        'icon.secondary-3.medium': '#F8CAAA',
        'icon.secondary-3.strong': '#FDF0E8',
        'icon.secondary-3.subtle': '#5C2314',
        'icon.secondary-4.default': '#EE9F99',
        'icon.secondary-4.low': '#9B4138',
        'icon.secondary-4.medium': '#F5C2CB',
        'icon.secondary-4.strong': '#FDE8EC',
        'icon.secondary-4.subtle': '#521F1B',
        'icon.secondary-5.default': '#A38ABF',
        'icon.secondary-5.low': '#64466C',
        'icon.secondary-5.medium': '#CFC1E1',
        'icon.secondary-5.strong': '#F3EEF7',
        'icon.secondary-5.subtle': '#3A2640',
        'icon.selected': '#4DA89C',
        'icon.success': '#96DF3C',
        'icon.tertiary': '#6B6861',
        'icon.warning': '#EDD441',
        page: '#161616',
        'shadow.inner': '#FDFDFC33',
        'shadow.lg': '#28272599',
        'shadow.md': '#28272566',
        'shadow.sm': '#28272533',
        'shadow.xl': '#282725CC',
        'shadow.xs': '#2827251F',
        'state-layer.hover': '#FDFDFC14',
        'state-layer.hover-alt': '#28272529',
        'state-layer.hover-brand': '#B8ECE029',
        'state-layer.hover-on-color': '#FDFDFC33',
        'state-layer.inverse.hover': '#28272514',
        'state-layer.inverse.hover-brand': '#B8ECE033',
        'state-layer.inverse.hover-on-color': '#FDFDFC33',
        'state-layer.inverse.press': '#28272529',
        'state-layer.inverse.press-brand': '#B8ECE066',
        'state-layer.inverse.press-on-color': '#28272566',
        'state-layer.press': '#FDFDFC29',
        'state-layer.press-alt': '#28272566',
        'state-layer.press-brand': '#B8ECE066',
        'state-layer.press-on-color': '#FDFDFC66',
        'surface.brand.bold': '#E8F8F4',
        'surface.brand.bold-alt': '#B4ECDF',
        'surface.brand.default': '#4DA89C',
        'surface.brand.default-alt': '#4DA89C',
        'surface.brand.secondary-1.default': '#A0C462',
        'surface.brand.secondary-1.low': '#5C7530',
        'surface.brand.secondary-1.medium': '#D2E4A8',
        'surface.brand.secondary-1.strong': '#F4F8E8',
        'surface.brand.secondary-1.subtle': '#344417',
        'surface.brand.secondary-1.translucent.default': '#D2E4A833',
        'surface.brand.secondary-1.translucent.low': '#D2E4A814',
        'surface.brand.secondary-1.translucent.medium': '#D2E4A866',
        'surface.brand.secondary-1.translucent.strong': '#D2E4A899',
        'surface.brand.secondary-1.translucent.subtle': '#D2E4A80A',
        'surface.brand.secondary-2.default': '#F7E9AB',
        'surface.brand.secondary-2.low': '#B5832C',
        'surface.brand.secondary-2.medium': '#EECA60',
        'surface.brand.secondary-2.strong': '#FDF8E8',
        'surface.brand.secondary-2.subtle': '#6A4B17',
        'surface.brand.secondary-2.translucent.default': '#F2D87A33',
        'surface.brand.secondary-2.translucent.low': '#F2D87A14',
        'surface.brand.secondary-2.translucent.medium': '#F2D87A66',
        'surface.brand.secondary-2.translucent.strong': '#F2D87A99',
        'surface.brand.secondary-2.translucent.subtle': '#F2D87A0A',
        'surface.brand.secondary-3.default': '#EFA87A',
        'surface.brand.secondary-3.low': '#9E4C2A',
        'surface.brand.secondary-3.medium': '#F8CAAA',
        'surface.brand.secondary-3.strong': '#FDF0E8',
        'surface.brand.secondary-3.subtle': '#5C2314',
        'surface.brand.secondary-3.translucent.default': '#F8CAAA33',
        'surface.brand.secondary-3.translucent.low': '#F8CAAA14',
        'surface.brand.secondary-3.translucent.medium': '#F8CAAA66',
        'surface.brand.secondary-3.translucent.strong': '#F8CAAA99',
        'surface.brand.secondary-3.translucent.subtle': '#F8CAAA0A',
        'surface.brand.secondary-4.default': '#EE9F99',
        'surface.brand.secondary-4.low': '#9B4138',
        'surface.brand.secondary-4.medium': '#F5C2CB',
        'surface.brand.secondary-4.strong': '#FDE8EC',
        'surface.brand.secondary-4.subtle': '#521F1B',
        'surface.brand.secondary-4.translucent.default': '#F5C2CB33',
        'surface.brand.secondary-4.translucent.low': '#F5C2CB14',
        'surface.brand.secondary-4.translucent.medium': '#F5C2CB66',
        'surface.brand.secondary-4.translucent.strong': '#F5C2CB99',
        'surface.brand.secondary-4.translucent.subtle': '#F5C2CB0A',
        'surface.brand.secondary-5.default': '#A38ABF',
        'surface.brand.secondary-5.low': '#64466C',
        'surface.brand.secondary-5.medium': '#CFC1E1',
        'surface.brand.secondary-5.strong': '#F3EEF7',
        'surface.brand.secondary-5.subtle': '#3A2640',
        'surface.brand.secondary-5.translucent.default': '#CFC1E133',
        'surface.brand.secondary-5.translucent.low': '#CFC1E114',
        'surface.brand.secondary-5.translucent.medium': '#CFC1E166',
        'surface.brand.secondary-5.translucent.strong': '#CFC1E199',
        'surface.brand.secondary-5.translucent.subtle': '#CFC1E10A',
        'surface.brand.strong': '#E8F8F4',
        'surface.brand.strong-alt': '#E8F8F4',
        'surface.brand.subtle': '#236B61',
        'surface.brand.subtle-alt': '#236B61',
        'surface.brand.translucent.bold': '#B8ECE066',
        'surface.brand.translucent.bold-alt': '#B8ECE066',
        'surface.brand.translucent.default': '#B8ECE033',
        'surface.brand.translucent.strong': '#B8ECE066',
        'surface.brand.translucent.strong-alt': '#B8ECE066',
        'surface.brand.translucent.subtle': '#B8ECE014',
        'surface.default': '#282725',
        'surface.disabled': '#FDFDFC33',
        'surface.error.default': '#FD6C6F',
        'surface.error.low': '#BE171B',
        'surface.error.medium': '#FFC8C9',
        'surface.error.strong': '#FEF2F2',
        'surface.error.subtle': '#470809',
        'surface.error.translucent.default': '#F53E4266',
        'surface.error.translucent.strong': '#F53E4299',
        'surface.error.translucent.subtle': '#F53E4229',
        'surface.info.default': '#5C9CEF',
        'surface.info.low': '#255594',
        'surface.info.medium': '#ADCDF7',
        'surface.info.strong': '#EBF3FE',
        'surface.info.subtle': '#121A27',
        'surface.info.translucent.default': '#3383EB66',
        'surface.info.translucent.strong': '#3383EB99',
        'surface.info.translucent.subtle': '#3383EB29',
        'surface.interactive': '#4DA89C',
        'surface.inverse.default': '#FFFFFF',
        'surface.inverse.disabled': '#28272533',
        'surface.inverse.primary-neutral': '#9B988C',
        'surface.inverse.secondary-neutral': '#6B6861',
        'surface.inverse.selected': '#236B61',
        'surface.inverse.selected-strong': '#FFFFFF',
        'surface.inverse.tertiary-neutral': '#3E3B38',
        'surface.overlay': '#28272566',
        'surface.primary': '#B8ECE014',
        'surface.primary-alt': '#0E2720',
        'surface.primary-neutral': '#28272599',
        'surface.secondary': '#B8ECE01F',
        'surface.secondary-alt': '#1A3D32',
        'surface.secondary-neutral': '#FDFDFC14',
        'surface.selected': '#236B61',
        'surface.selected-strong': '#4DA89C',
        'surface.strong-neutral': '#282725CC',
        'surface.success.default': '#96DF3C',
        'surface.success.low': '#457714',
        'surface.success.medium': '#CDF496',
        'surface.success.strong': '#F6FDE8',
        'surface.success.subtle': '#182C07',
        'surface.success.translucent.default': '#77C41E66',
        'surface.success.translucent.strong': '#77C41E99',
        'surface.success.translucent.subtle': '#77C41E29',
        'surface.tertiary': '#B8ECE029',
        'surface.tertiary-alt': '#315B4A',
        'surface.tertiary-neutral': '#FDFDFC29',
        'surface.translucent.default': '#2827250A',
        'surface.translucent.disabled': '#FDFDFC1F',
        'surface.translucent.primary': '#B8ECE014',
        'surface.translucent.primary-alt': '#B8ECE014',
        'surface.translucent.primary-neutral': '#FDFDFC14',
        'surface.translucent.secondary': '#B8ECE029',
        'surface.translucent.secondary-alt': '#B8ECE029',
        'surface.translucent.secondary-neutral': '#FDFDFC29',
        'surface.translucent.selected': '#B8ECE029',
        'surface.translucent.strong-neutral': '#FDFDFC66',
        'surface.translucent.tertiary': '#B8ECE066',
        'surface.translucent.tertiary-alt': '#B8ECE033',
        'surface.translucent.tertiary-neutral': '#FDFDFC33',
        'surface.warning.default': '#E8C427',
        'surface.warning.low': '#956213',
        'surface.warning.medium': '#F5EA93',
        'surface.warning.strong': '#FCFBEA',
        'surface.warning.subtle': '#3D220B',
        'surface.warning.translucent.default': '#D8AD1A66',
        'surface.warning.translucent.strong': '#D8AD1A99',
        'surface.warning.translucent.subtle': '#D8AD1A29',
        'text.brand': '#8EDED0',
        'text.brand-alt': '#1F2635',
        'text.disabled': '#FDFDFC66',
        'text.emphasized': '#4DA89C',
        'text.error': '#FD6C6F',
        'text.info': '#85B5F3',
        'text.interactive': '#4DA89C',
        'text.inverse.disabled': '#28272566',
        'text.inverse.emphasized': '#236B61',
        'text.inverse.interactive': '#3A9488',
        'text.inverse.primary': '#282725',
        'text.inverse.secondary': '#6B6861',
        'text.primary': '#FFFFFF',
        'text.secondary': '#C6C3B9',
        'text.secondary-1.default': '#A0C462',
        'text.secondary-1.low': '#5C7530',
        'text.secondary-1.medium': '#D2E4A8',
        'text.secondary-1.strong': '#F4F8E8',
        'text.secondary-1.subtle': '#344417',
        'text.secondary-2.default': '#F7E9AB',
        'text.secondary-2.low': '#B5832C',
        'text.secondary-2.medium': '#EECA60',
        'text.secondary-2.strong': '#FDF8E8',
        'text.secondary-2.subtle': '#6A4B17',
        'text.secondary-3.default': '#EFA87A',
        'text.secondary-3.low': '#9E4C2A',
        'text.secondary-3.medium': '#F8CAAA',
        'text.secondary-3.strong': '#FDF0E8',
        'text.secondary-3.subtle': '#5C2314',
        'text.secondary-4.default': '#EE9F99',
        'text.secondary-4.low': '#9B4138',
        'text.secondary-4.medium': '#F5C2CB',
        'text.secondary-4.strong': '#FDE8EC',
        'text.secondary-4.subtle': '#521F1B',
        'text.secondary-5.default': '#A38ABF',
        'text.secondary-5.low': '#64466C',
        'text.secondary-5.medium': '#CFC1E1',
        'text.secondary-5.strong': '#F3EEF7',
        'text.secondary-5.subtle': '#3A2640',
        'text.selected': '#4DA89C',
        'text.success': '#96DF3C',
        'text.tertiary': '#6B6861',
        'text.warning': '#EDD441',
        white: '#FFFFFF',
        'white-label.footer.footer-bg': '#1F2635',
        'white-label.header.bg': '#161616',
        'white-label.header.on-header': '#FFFFFF',
        'white-label.headerSubtext': '#FFFFFF',
        'white-label.highlight': '#FFFFFF',
        'white-label.highlightText': '#FFFFFF',
        'white-label.notificationLogoBackground': '#FFFFFF',
        'white-label.publish-button.bg.header-bar': '#FFFFFF',
        'white-label.publish-button.bg.mobile-bottom-tab-bar': '#FFFFFF',
        'white-label.publish-button.icon.header-bar': '#1F2635',
        'white-label.publish-button.icon.mobile-bottom-tab-bar': '#1F2635',
        'white-label.publish-button.label.primary': '#1F2635',
        'white-label.splash': '#B8ECE0',
        'white-label.theme.icon.on-brand-accent': '#1F2635',
        'white-label.theme.surface.accent': '#FFFFFF',
        'white-label.theme.surface.primary': '#1F2635',
        'white-label.theme.text.on-brand-accent': '#1F2635',
      },
      responsive: {
        'border-width.bold': '4',
        'border-width.emphasized': '2',
        'border-width.standard': '1.5',
        'border-width.subtle': '1',
        'motion.distance.component-enter': '8',
        'motion.distance.feedback': '2',
        'motion.distance.overlay-enter': '12',
        'motion.distance.page-enter': '16',
        'motion.duration.component-transition': '[object Object]',
        'motion.duration.feedback': '[object Object]',
        'motion.duration.micro-transition': '[object Object]',
        'motion.duration.overlay-transition': '[object Object]',
        'motion.duration.page-transition': '[object Object]',
        'motion.duration.passive': '[object Object]',
        'motion.easing.continuous': '0,0,1,1',
        'motion.easing.emphasize': '0.05000000074505806,0.699999988079071,0.10000000149011612,1',
        'motion.easing.enter': '0,0,0,1',
        'motion.easing.exit': '0.4000000059604645,0,1,1',
        'motion.easing.move': '0.20000000298023224,0,0,1',
        'motion.scale.emphasize': '1.0199999809265137',
        'motion.scale.enter': '0.9599999785423279',
        'motion.scale.press': '0.9800000190734863',
        'motion.stagger.relaxed': '[object Object]',
        'motion.stagger.standard': '[object Object]',
        'motion.stagger.tight': '[object Object]',
        'radius.component.fields.input': '16',
        'radius.component.publish-button.button-radius': '8',
        'radius.full': '1000',
        'radius.lg': '16',
        'radius.md': '12',
        'radius.none': '0',
        'radius.sm': '8',
        'radius.xl': '24',
        'radius.xs': '4',
        'radius.xxl': '32',
        'radius.xxs': '2',
        'shadow.blur.lg': '16',
        'shadow.blur.md': '8',
        'shadow.blur.sm': '4',
        'shadow.blur.xl': '24',
        'shadow.blur.xs': '2',
        'shadow.offset-y.lg': '4',
        'shadow.offset-y.md': '2',
        'shadow.offset-y.sm': '1',
        'shadow.offset-y.xl': '8',
        'shadow.offset-y.xs': '1',
        'sizing.body.max-width': '767',
        'sizing.body.min-width': '320',
        'sizing.component.button.height.large': '56',
        'sizing.component.button.height.large-icn-button': '48',
        'sizing.component.button.height.medium': '40',
        'sizing.component.button.height.small': '32',
        'sizing.component.header.max-width': '767',
        'sizing.component.header.min-width': '320',
        'sizing.general.0': '0',
        'sizing.general.x0,25': '1',
        'sizing.general.x0,5': '2',
        'sizing.general.x1': '4',
        'sizing.general.x10': '40',
        'sizing.general.x100': '400',
        'sizing.general.x12': '48',
        'sizing.general.x120': '480',
        'sizing.general.x14': '56',
        'sizing.general.x140': '560',
        'sizing.general.x150': '600',
        'sizing.general.x16': '64',
        'sizing.general.x160': '640',
        'sizing.general.x18': '72',
        'sizing.general.x180': '720',
        'sizing.general.x2': '8',
        'sizing.general.x20': '80',
        'sizing.general.x200': '800',
        'sizing.general.x22': '88',
        'sizing.general.x24': '96',
        'sizing.general.x3': '12',
        'sizing.general.x30': '120',
        'sizing.general.x36': '144',
        'sizing.general.x4': '16',
        'sizing.general.x40': '160',
        'sizing.general.x5': '20',
        'sizing.general.x50': '200',
        'sizing.general.x6': '24',
        'sizing.general.x60': '240',
        'sizing.general.x7': '28',
        'sizing.general.x70': '280',
        'sizing.general.x8': '32',
        'sizing.general.x80': '320',
        'sizing.general.x90': '360',
        'sizing.icon.default': '24',
        'sizing.icon.lg': '32',
        'sizing.icon.s': '16',
        'sizing.icon.sm': '20',
        'sizing.icon.xl': '56',
        'sizing.icon.xs': '12',
        'spacing.general.0': '0',
        'spacing.general.x0,5': '2',
        'spacing.general.x1': '4',
        'spacing.general.x10': '40',
        'spacing.general.x12': '48',
        'spacing.general.x14': '56',
        'spacing.general.x16': '64',
        'spacing.general.x18': '72',
        'spacing.general.x2': '8',
        'spacing.general.x20': '80',
        'spacing.general.x22': '88',
        'spacing.general.x24': '96',
        'spacing.general.x3': '12',
        'spacing.general.x30': '120',
        'spacing.general.x36': '144',
        'spacing.general.x4': '16',
        'spacing.general.x5': '20',
        'spacing.general.x6': '24',
        'spacing.general.x7': '28',
        'spacing.general.x8': '32',
        'spacing.semantic.bottom-safe-zone': '36',
        'spacing.semantic.line-height-fix': '2',
        'spacing.semantic.page-margin': '16',
        'typography.font-size.body.base': '16',
        'typography.font-size.body.caption-base': '10',
        'typography.font-size.body.caption-large': '12',
        'typography.font-size.body.large': '18',
        'typography.font-size.body.small': '14',
        'typography.font-size.body.x-large': '20',
        'typography.font-size.body.x-small': '12',
        'typography.font-size.header.display-1': '48',
        'typography.font-size.header.display-2': '56',
        'typography.font-size.header.large': '40',
        'typography.font-size.header.medium': '28',
        'typography.font-size.header.small': '24',
        'typography.font-size.header.x-small': '20',
        'typography.font-size.link.link-base': '16',
        'typography.font-size.link.link-large': '20',
        'typography.font-size.link.link-small': '14',
        'typography.letter-spacing.body.base': '0',
        'typography.letter-spacing.body.caption': '0',
        'typography.letter-spacing.body.large': '0',
        'typography.letter-spacing.body.small': '0',
        'typography.letter-spacing.body.x-large': '0',
        'typography.letter-spacing.body.x-small': '0',
        'typography.letter-spacing.header.display-1': '0',
        'typography.letter-spacing.header.display-2': '0',
        'typography.letter-spacing.header.large': '0',
        'typography.letter-spacing.header.medium': '0',
        'typography.letter-spacing.header.small': '0',
        'typography.letter-spacing.header.x-small': '0',
      },
      styles: {
        header: {
          'display-2': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '56',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'display-1': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '48',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '40',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '40', letterSpacing: '0', lineHeight: 'normal' },
          },
          medium: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '28',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'medium-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '28', letterSpacing: '0', lineHeight: 'normal' },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '24',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '24', letterSpacing: '0', lineHeight: 'normal' },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '20', letterSpacing: '0', lineHeight: 'normal' },
          },
        },
        body: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '700', fontSize: '18', letterSpacing: '0', lineHeight: '120%' },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '400', fontSize: '14', letterSpacing: '0', lineHeight: '120%' },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        caption: {
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        paragraph: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        link: {
          'link-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
        },
      },
    },
    medium: {
      brand: 'legacy',
      mode: 'dark',
      breakpoint: 'medium',
      colors: {
        black: '#1F2635',
        'border.brand': '#8EDED0',
        'border.brand-alt': '#1A3D32',
        'border.disabled': '#28272529',
        'border.divider': '#FDFDFC33',
        'border.error': '#FD6C6F',
        'border.focused': '#4DA89C',
        'border.info': '#5C9CEF',
        'border.interactive': '#4DA89C',
        'border.inverse.disabled': '#28272566',
        'border.inverse.divider': '#2827251F',
        'border.inverse.interactive': '#3A9488',
        'border.inverse.primary': '#28272566',
        'border.inverse.secondary': '#28272529',
        'border.inverse.selected': '#236B61',
        'border.inverse.strong': '#1F2635',
        'border.primary': '#FDFDFC66',
        'border.secondary': '#FDFDFC29',
        'border.secondary-1.default': '#A0C462',
        'border.secondary-1.strong': '#F4F8E8',
        'border.secondary-1.subtle': '#5C7530',
        'border.secondary-2.default': '#EECA60',
        'border.secondary-2.strong': '#FDF8E8',
        'border.secondary-2.subtle': '#B5832C',
        'border.secondary-3.default': '#E39464',
        'border.secondary-3.strong': '#FDF0E8',
        'border.secondary-3.subtle': '#9E4C2A',
        'border.secondary-4.default': '#EE9F99',
        'border.secondary-4.strong': '#FDE8EC',
        'border.secondary-4.subtle': '#9B4138',
        'border.secondary-5.default': '#A38ABF',
        'border.secondary-5.low': '#64466C',
        'border.secondary-5.medium': '#CFC1E1',
        'border.secondary-5.strong': '#F3EEF7',
        'border.secondary-5.subtle': '#3A2640',
        'border.selected': '#236B61',
        'border.strong': '#FFFFFF',
        'border.success': '#96DF3C',
        'border.warning': '#E8C427',
        'component.button.bg.hover': '#28272533',
        'component.button.bg.inverted': '#1F2635',
        'component.button.bg.pressed': '#28272599',
        'component.button.bg.primary': '#FFFFFF',
        'component.button.bg.secondary': '#8EDED0',
        'component.button.bg.tertiary': '#3E3B38',
        'component.button.bg.transparent': '#FDFDFC66',
        'component.button.border.tertiary': '#FFFFFF',
        'component.button.icon.tertiary': '#FFFFFF',
        'component.button.label.tertiary': '#FFFFFF',
        'concept.ambassador.border': '#7C4D17',
        'concept.ambassador.icon': '#E8C427',
        'concept.ambassador.surface.default': '#E8C427',
        'concept.ambassador.surface.strong': '#F9F6C8',
        'concept.ambassador.surface.subtle': '#3D220B',
        'concept.ambassador.text': '#EDD441',
        'concept.exoneration.border': '#9D3D0F',
        'concept.exoneration.icon': '#FFAD54',
        'concept.exoneration.surface.default': '#4DA89C',
        'concept.exoneration.surface.low': '#B8ECE0',
        'concept.exoneration.surface.medium': '#8EDED0',
        'concept.exoneration.surface.strong': '#B8ECE0',
        'concept.exoneration.surface.subtle': '#1F2635',
        'concept.exoneration.text': '#FFC471',
        'concept.pension.border': '#3A5F15',
        'concept.pension.icon': '#96DF3C',
        'concept.pension.surface.default': '#5C9CEF',
        'concept.pension.surface.strong': '#D6E6FB',
        'concept.pension.surface.subtle': '#121A27',
        'concept.pension.text-on-dark': '#B3EC6A',
        'concept.pension.text-on-light': '#B3EC6A',
        'concept.plan.free.icon-on-surface': '#FFFFFF',
        'concept.plan.free.surface.default': '#5C9CEF',
        'concept.plan.free.surface.low': '#1C3C68',
        'concept.plan.free.surface.medium': '#ADCDF7',
        'concept.plan.free.surface.strong': '#D6E6FB',
        'concept.plan.free.surface.subtle': '#121A27',
        'concept.plan.free.text-on-surface': '#FFFFFF',
        'concept.plan.premium.accent': '#F7E9AB',
        'concept.plan.premium.border': '#4F3556',
        'concept.plan.premium.icon-on-surface': '#A38ABF',
        'concept.plan.premium.surface.default': '#A38ABF',
        'concept.plan.premium.surface.low': '#4F3556',
        'concept.plan.premium.surface.medium': '#CFC1E1',
        'concept.plan.premium.surface.strong': '#E5DAEF',
        'concept.plan.premium.surface.subtle': '#231728',
        'concept.plan.premium.text-on-surface': '#B8A4D0',
        'concept.trust-club.border': '#6E4C4E',
        'concept.trust-club.icon': '#FFBABC',
        'concept.trust-club.surface.default': '#FFBABC',
        'concept.trust-club.surface.strong': '#FFEEEE',
        'concept.trust-club.surface.subtle': '#261E20',
        'concept.trust-club.text-on-dark': '#FFCBCD',
        'concept.trust-club.text-on-light': '#FFCBCD',
        'gradient.bottom-tab-bar-end': '#161616E5',
        'gradient.bottom-tab-bar-start': '#16161600',
        'gradient.primary': '#16161600',
        'icon.brand': '#8EDED0',
        'icon.brand-alt': '#1F2635',
        'icon.disabled': '#FDFDFC66',
        'icon.emphasized': '#4DA89C',
        'icon.error': '#FD6C6F',
        'icon.info': '#85B5F3',
        'icon.interactive': '#4DA89C',
        'icon.inverse.disabled': '#28272566',
        'icon.inverse.interactive': '#3A9488',
        'icon.inverse.on-selected': '#4DA89C',
        'icon.inverse.primary': '#1F2635',
        'icon.inverse.secondary': '#6B6861',
        'icon.primary': '#FFFFFF',
        'icon.secondary': '#C6C3B9',
        'icon.secondary-1.default': '#A0C462',
        'icon.secondary-1.low': '#5C7530',
        'icon.secondary-1.medium': '#D2E4A8',
        'icon.secondary-1.strong': '#F4F8E8',
        'icon.secondary-1.subtle': '#344417',
        'icon.secondary-2.default': '#EECA60',
        'icon.secondary-2.low': '#B5832C',
        'icon.secondary-2.medium': '#F7E9AB',
        'icon.secondary-2.strong': '#FDF8E8',
        'icon.secondary-2.subtle': '#6A4B17',
        'icon.secondary-3.default': '#E39464',
        'icon.secondary-3.low': '#9E4C2A',
        'icon.secondary-3.medium': '#F8CAAA',
        'icon.secondary-3.strong': '#FDF0E8',
        'icon.secondary-3.subtle': '#5C2314',
        'icon.secondary-4.default': '#EE9F99',
        'icon.secondary-4.low': '#9B4138',
        'icon.secondary-4.medium': '#F5C2CB',
        'icon.secondary-4.strong': '#FDE8EC',
        'icon.secondary-4.subtle': '#521F1B',
        'icon.secondary-5.default': '#A38ABF',
        'icon.secondary-5.low': '#64466C',
        'icon.secondary-5.medium': '#CFC1E1',
        'icon.secondary-5.strong': '#F3EEF7',
        'icon.secondary-5.subtle': '#3A2640',
        'icon.selected': '#4DA89C',
        'icon.success': '#96DF3C',
        'icon.tertiary': '#6B6861',
        'icon.warning': '#EDD441',
        page: '#161616',
        'shadow.inner': '#FDFDFC33',
        'shadow.lg': '#28272599',
        'shadow.md': '#28272566',
        'shadow.sm': '#28272533',
        'shadow.xl': '#282725CC',
        'shadow.xs': '#2827251F',
        'state-layer.hover': '#FDFDFC14',
        'state-layer.hover-alt': '#28272529',
        'state-layer.hover-brand': '#B8ECE029',
        'state-layer.hover-on-color': '#FDFDFC33',
        'state-layer.inverse.hover': '#28272514',
        'state-layer.inverse.hover-brand': '#B8ECE033',
        'state-layer.inverse.hover-on-color': '#FDFDFC33',
        'state-layer.inverse.press': '#28272529',
        'state-layer.inverse.press-brand': '#B8ECE066',
        'state-layer.inverse.press-on-color': '#28272566',
        'state-layer.press': '#FDFDFC29',
        'state-layer.press-alt': '#28272566',
        'state-layer.press-brand': '#B8ECE066',
        'state-layer.press-on-color': '#FDFDFC66',
        'surface.brand.bold': '#E8F8F4',
        'surface.brand.bold-alt': '#B4ECDF',
        'surface.brand.default': '#4DA89C',
        'surface.brand.default-alt': '#4DA89C',
        'surface.brand.secondary-1.default': '#A0C462',
        'surface.brand.secondary-1.low': '#5C7530',
        'surface.brand.secondary-1.medium': '#D2E4A8',
        'surface.brand.secondary-1.strong': '#F4F8E8',
        'surface.brand.secondary-1.subtle': '#344417',
        'surface.brand.secondary-1.translucent.default': '#D2E4A833',
        'surface.brand.secondary-1.translucent.low': '#D2E4A814',
        'surface.brand.secondary-1.translucent.medium': '#D2E4A866',
        'surface.brand.secondary-1.translucent.strong': '#D2E4A899',
        'surface.brand.secondary-1.translucent.subtle': '#D2E4A80A',
        'surface.brand.secondary-2.default': '#F7E9AB',
        'surface.brand.secondary-2.low': '#B5832C',
        'surface.brand.secondary-2.medium': '#EECA60',
        'surface.brand.secondary-2.strong': '#FDF8E8',
        'surface.brand.secondary-2.subtle': '#6A4B17',
        'surface.brand.secondary-2.translucent.default': '#F2D87A33',
        'surface.brand.secondary-2.translucent.low': '#F2D87A14',
        'surface.brand.secondary-2.translucent.medium': '#F2D87A66',
        'surface.brand.secondary-2.translucent.strong': '#F2D87A99',
        'surface.brand.secondary-2.translucent.subtle': '#F2D87A0A',
        'surface.brand.secondary-3.default': '#EFA87A',
        'surface.brand.secondary-3.low': '#9E4C2A',
        'surface.brand.secondary-3.medium': '#F8CAAA',
        'surface.brand.secondary-3.strong': '#FDF0E8',
        'surface.brand.secondary-3.subtle': '#5C2314',
        'surface.brand.secondary-3.translucent.default': '#F8CAAA33',
        'surface.brand.secondary-3.translucent.low': '#F8CAAA14',
        'surface.brand.secondary-3.translucent.medium': '#F8CAAA66',
        'surface.brand.secondary-3.translucent.strong': '#F8CAAA99',
        'surface.brand.secondary-3.translucent.subtle': '#F8CAAA0A',
        'surface.brand.secondary-4.default': '#EE9F99',
        'surface.brand.secondary-4.low': '#9B4138',
        'surface.brand.secondary-4.medium': '#F5C2CB',
        'surface.brand.secondary-4.strong': '#FDE8EC',
        'surface.brand.secondary-4.subtle': '#521F1B',
        'surface.brand.secondary-4.translucent.default': '#F5C2CB33',
        'surface.brand.secondary-4.translucent.low': '#F5C2CB14',
        'surface.brand.secondary-4.translucent.medium': '#F5C2CB66',
        'surface.brand.secondary-4.translucent.strong': '#F5C2CB99',
        'surface.brand.secondary-4.translucent.subtle': '#F5C2CB0A',
        'surface.brand.secondary-5.default': '#A38ABF',
        'surface.brand.secondary-5.low': '#64466C',
        'surface.brand.secondary-5.medium': '#CFC1E1',
        'surface.brand.secondary-5.strong': '#F3EEF7',
        'surface.brand.secondary-5.subtle': '#3A2640',
        'surface.brand.secondary-5.translucent.default': '#CFC1E133',
        'surface.brand.secondary-5.translucent.low': '#CFC1E114',
        'surface.brand.secondary-5.translucent.medium': '#CFC1E166',
        'surface.brand.secondary-5.translucent.strong': '#CFC1E199',
        'surface.brand.secondary-5.translucent.subtle': '#CFC1E10A',
        'surface.brand.strong': '#E8F8F4',
        'surface.brand.strong-alt': '#E8F8F4',
        'surface.brand.subtle': '#236B61',
        'surface.brand.subtle-alt': '#236B61',
        'surface.brand.translucent.bold': '#B8ECE066',
        'surface.brand.translucent.bold-alt': '#B8ECE066',
        'surface.brand.translucent.default': '#B8ECE033',
        'surface.brand.translucent.strong': '#B8ECE066',
        'surface.brand.translucent.strong-alt': '#B8ECE066',
        'surface.brand.translucent.subtle': '#B8ECE014',
        'surface.default': '#282725',
        'surface.disabled': '#FDFDFC33',
        'surface.error.default': '#FD6C6F',
        'surface.error.low': '#BE171B',
        'surface.error.medium': '#FFC8C9',
        'surface.error.strong': '#FEF2F2',
        'surface.error.subtle': '#470809',
        'surface.error.translucent.default': '#F53E4266',
        'surface.error.translucent.strong': '#F53E4299',
        'surface.error.translucent.subtle': '#F53E4229',
        'surface.info.default': '#5C9CEF',
        'surface.info.low': '#255594',
        'surface.info.medium': '#ADCDF7',
        'surface.info.strong': '#EBF3FE',
        'surface.info.subtle': '#121A27',
        'surface.info.translucent.default': '#3383EB66',
        'surface.info.translucent.strong': '#3383EB99',
        'surface.info.translucent.subtle': '#3383EB29',
        'surface.interactive': '#4DA89C',
        'surface.inverse.default': '#FFFFFF',
        'surface.inverse.disabled': '#28272533',
        'surface.inverse.primary-neutral': '#9B988C',
        'surface.inverse.secondary-neutral': '#6B6861',
        'surface.inverse.selected': '#236B61',
        'surface.inverse.selected-strong': '#FFFFFF',
        'surface.inverse.tertiary-neutral': '#3E3B38',
        'surface.overlay': '#28272566',
        'surface.primary': '#B8ECE014',
        'surface.primary-alt': '#0E2720',
        'surface.primary-neutral': '#28272599',
        'surface.secondary': '#B8ECE01F',
        'surface.secondary-alt': '#1A3D32',
        'surface.secondary-neutral': '#FDFDFC14',
        'surface.selected': '#236B61',
        'surface.selected-strong': '#4DA89C',
        'surface.strong-neutral': '#282725CC',
        'surface.success.default': '#96DF3C',
        'surface.success.low': '#457714',
        'surface.success.medium': '#CDF496',
        'surface.success.strong': '#F6FDE8',
        'surface.success.subtle': '#182C07',
        'surface.success.translucent.default': '#77C41E66',
        'surface.success.translucent.strong': '#77C41E99',
        'surface.success.translucent.subtle': '#77C41E29',
        'surface.tertiary': '#B8ECE029',
        'surface.tertiary-alt': '#315B4A',
        'surface.tertiary-neutral': '#FDFDFC29',
        'surface.translucent.default': '#2827250A',
        'surface.translucent.disabled': '#FDFDFC1F',
        'surface.translucent.primary': '#B8ECE014',
        'surface.translucent.primary-alt': '#B8ECE014',
        'surface.translucent.primary-neutral': '#FDFDFC14',
        'surface.translucent.secondary': '#B8ECE029',
        'surface.translucent.secondary-alt': '#B8ECE029',
        'surface.translucent.secondary-neutral': '#FDFDFC29',
        'surface.translucent.selected': '#B8ECE029',
        'surface.translucent.strong-neutral': '#FDFDFC66',
        'surface.translucent.tertiary': '#B8ECE066',
        'surface.translucent.tertiary-alt': '#B8ECE033',
        'surface.translucent.tertiary-neutral': '#FDFDFC33',
        'surface.warning.default': '#E8C427',
        'surface.warning.low': '#956213',
        'surface.warning.medium': '#F5EA93',
        'surface.warning.strong': '#FCFBEA',
        'surface.warning.subtle': '#3D220B',
        'surface.warning.translucent.default': '#D8AD1A66',
        'surface.warning.translucent.strong': '#D8AD1A99',
        'surface.warning.translucent.subtle': '#D8AD1A29',
        'text.brand': '#8EDED0',
        'text.brand-alt': '#1F2635',
        'text.disabled': '#FDFDFC66',
        'text.emphasized': '#4DA89C',
        'text.error': '#FD6C6F',
        'text.info': '#85B5F3',
        'text.interactive': '#4DA89C',
        'text.inverse.disabled': '#28272566',
        'text.inverse.emphasized': '#236B61',
        'text.inverse.interactive': '#3A9488',
        'text.inverse.primary': '#282725',
        'text.inverse.secondary': '#6B6861',
        'text.primary': '#FFFFFF',
        'text.secondary': '#C6C3B9',
        'text.secondary-1.default': '#A0C462',
        'text.secondary-1.low': '#5C7530',
        'text.secondary-1.medium': '#D2E4A8',
        'text.secondary-1.strong': '#F4F8E8',
        'text.secondary-1.subtle': '#344417',
        'text.secondary-2.default': '#F7E9AB',
        'text.secondary-2.low': '#B5832C',
        'text.secondary-2.medium': '#EECA60',
        'text.secondary-2.strong': '#FDF8E8',
        'text.secondary-2.subtle': '#6A4B17',
        'text.secondary-3.default': '#EFA87A',
        'text.secondary-3.low': '#9E4C2A',
        'text.secondary-3.medium': '#F8CAAA',
        'text.secondary-3.strong': '#FDF0E8',
        'text.secondary-3.subtle': '#5C2314',
        'text.secondary-4.default': '#EE9F99',
        'text.secondary-4.low': '#9B4138',
        'text.secondary-4.medium': '#F5C2CB',
        'text.secondary-4.strong': '#FDE8EC',
        'text.secondary-4.subtle': '#521F1B',
        'text.secondary-5.default': '#A38ABF',
        'text.secondary-5.low': '#64466C',
        'text.secondary-5.medium': '#CFC1E1',
        'text.secondary-5.strong': '#F3EEF7',
        'text.secondary-5.subtle': '#3A2640',
        'text.selected': '#4DA89C',
        'text.success': '#96DF3C',
        'text.tertiary': '#6B6861',
        'text.warning': '#EDD441',
        white: '#FFFFFF',
        'white-label.footer.footer-bg': '#1F2635',
        'white-label.header.bg': '#161616',
        'white-label.header.on-header': '#FFFFFF',
        'white-label.headerSubtext': '#FFFFFF',
        'white-label.highlight': '#FFFFFF',
        'white-label.highlightText': '#FFFFFF',
        'white-label.notificationLogoBackground': '#FFFFFF',
        'white-label.publish-button.bg.header-bar': '#FFFFFF',
        'white-label.publish-button.bg.mobile-bottom-tab-bar': '#FFFFFF',
        'white-label.publish-button.icon.header-bar': '#1F2635',
        'white-label.publish-button.icon.mobile-bottom-tab-bar': '#1F2635',
        'white-label.publish-button.label.primary': '#1F2635',
        'white-label.splash': '#B8ECE0',
        'white-label.theme.icon.on-brand-accent': '#1F2635',
        'white-label.theme.surface.accent': '#FFFFFF',
        'white-label.theme.surface.primary': '#1F2635',
        'white-label.theme.text.on-brand-accent': '#1F2635',
      },
      responsive: {
        'border-width.bold': '4',
        'border-width.emphasized': '2',
        'border-width.standard': '1.5',
        'border-width.subtle': '1',
        'motion.distance.component-enter': '8',
        'motion.distance.feedback': '2',
        'motion.distance.overlay-enter': '16',
        'motion.distance.page-enter': '24',
        'motion.duration.component-transition': '[object Object]',
        'motion.duration.feedback': '[object Object]',
        'motion.duration.micro-transition': '[object Object]',
        'motion.duration.overlay-transition': '[object Object]',
        'motion.duration.page-transition': '[object Object]',
        'motion.duration.passive': '[object Object]',
        'motion.easing.continuous': '0,0,1,1',
        'motion.easing.emphasize': '0.05000000074505806,0.699999988079071,0.10000000149011612,1',
        'motion.easing.enter': '0,0,0,1',
        'motion.easing.exit': '0.4000000059604645,0,1,1',
        'motion.easing.move': '0.20000000298023224,0,0,1',
        'motion.scale.emphasize': '1.0199999809265137',
        'motion.scale.enter': '0.9599999785423279',
        'motion.scale.press': '0.9800000190734863',
        'motion.stagger.relaxed': '[object Object]',
        'motion.stagger.standard': '[object Object]',
        'motion.stagger.tight': '[object Object]',
        'radius.component.fields.input': '16',
        'radius.component.publish-button.button-radius': '8',
        'radius.full': '1000',
        'radius.lg': '16',
        'radius.md': '12',
        'radius.none': '0',
        'radius.sm': '8',
        'radius.xl': '24',
        'radius.xs': '4',
        'radius.xxl': '32',
        'radius.xxs': '2',
        'shadow.blur.lg': '24',
        'shadow.blur.md': '12',
        'shadow.blur.sm': '8',
        'shadow.blur.xl': '36',
        'shadow.blur.xs': '2',
        'shadow.offset-y.lg': '8',
        'shadow.offset-y.md': '4',
        'shadow.offset-y.sm': '2',
        'shadow.offset-y.xl': '16',
        'shadow.offset-y.xs': '1',
        'sizing.body.max-width': '1279',
        'sizing.body.min-width': '768',
        'sizing.component.button.height.large': '56',
        'sizing.component.button.height.large-icn-button': '48',
        'sizing.component.button.height.medium': '40',
        'sizing.component.button.height.small': '32',
        'sizing.component.header.max-width': '1279',
        'sizing.component.header.min-width': '768',
        'sizing.general.0': '0',
        'sizing.general.x0,25': '1',
        'sizing.general.x0,5': '2',
        'sizing.general.x1': '4',
        'sizing.general.x10': '40',
        'sizing.general.x100': '400',
        'sizing.general.x12': '48',
        'sizing.general.x120': '480',
        'sizing.general.x14': '56',
        'sizing.general.x140': '560',
        'sizing.general.x150': '600',
        'sizing.general.x16': '64',
        'sizing.general.x160': '640',
        'sizing.general.x18': '72',
        'sizing.general.x180': '720',
        'sizing.general.x2': '8',
        'sizing.general.x20': '80',
        'sizing.general.x200': '800',
        'sizing.general.x22': '88',
        'sizing.general.x24': '96',
        'sizing.general.x3': '12',
        'sizing.general.x30': '120',
        'sizing.general.x36': '144',
        'sizing.general.x4': '16',
        'sizing.general.x40': '160',
        'sizing.general.x5': '20',
        'sizing.general.x50': '200',
        'sizing.general.x6': '24',
        'sizing.general.x60': '240',
        'sizing.general.x7': '28',
        'sizing.general.x70': '280',
        'sizing.general.x8': '32',
        'sizing.general.x80': '320',
        'sizing.general.x90': '360',
        'sizing.icon.default': '24',
        'sizing.icon.lg': '32',
        'sizing.icon.s': '16',
        'sizing.icon.sm': '20',
        'sizing.icon.xl': '56',
        'sizing.icon.xs': '12',
        'spacing.general.0': '0',
        'spacing.general.x0,5': '2',
        'spacing.general.x1': '4',
        'spacing.general.x10': '40',
        'spacing.general.x12': '48',
        'spacing.general.x14': '56',
        'spacing.general.x16': '64',
        'spacing.general.x18': '72',
        'spacing.general.x2': '8',
        'spacing.general.x20': '80',
        'spacing.general.x22': '88',
        'spacing.general.x24': '96',
        'spacing.general.x3': '12',
        'spacing.general.x30': '120',
        'spacing.general.x36': '144',
        'spacing.general.x4': '16',
        'spacing.general.x5': '20',
        'spacing.general.x6': '24',
        'spacing.general.x7': '28',
        'spacing.general.x8': '32',
        'spacing.semantic.bottom-safe-zone': '36',
        'spacing.semantic.line-height-fix': '2',
        'spacing.semantic.page-margin': '32',
        'typography.font-size.body.base': '16',
        'typography.font-size.body.caption-base': '10',
        'typography.font-size.body.caption-large': '12',
        'typography.font-size.body.large': '18',
        'typography.font-size.body.small': '14',
        'typography.font-size.body.x-large': '20',
        'typography.font-size.body.x-small': '12',
        'typography.font-size.header.display-1': '48',
        'typography.font-size.header.display-2': '56',
        'typography.font-size.header.large': '40',
        'typography.font-size.header.medium': '32',
        'typography.font-size.header.small': '28',
        'typography.font-size.header.x-small': '24',
        'typography.font-size.link.link-base': '16',
        'typography.font-size.link.link-large': '20',
        'typography.font-size.link.link-small': '14',
        'typography.letter-spacing.body.base': '0',
        'typography.letter-spacing.body.caption': '0',
        'typography.letter-spacing.body.large': '0',
        'typography.letter-spacing.body.small': '0',
        'typography.letter-spacing.body.x-large': '0',
        'typography.letter-spacing.body.x-small': '0',
        'typography.letter-spacing.header.display-1': '0',
        'typography.letter-spacing.header.display-2': '0',
        'typography.letter-spacing.header.large': '0',
        'typography.letter-spacing.header.medium': '0',
        'typography.letter-spacing.header.small': '0',
        'typography.letter-spacing.header.x-small': '0',
      },
      styles: {
        header: {
          'display-2': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '56',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'display-1': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '48',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '40',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '40', letterSpacing: '0', lineHeight: 'normal' },
          },
          medium: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '32',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'medium-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '32', letterSpacing: '0', lineHeight: 'normal' },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '28',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '28', letterSpacing: '0', lineHeight: 'normal' },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '24',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '24', letterSpacing: '0', lineHeight: 'normal' },
          },
        },
        body: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '700', fontSize: '18', letterSpacing: '0', lineHeight: '120%' },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '400', fontSize: '14', letterSpacing: '0', lineHeight: '120%' },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        caption: {
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        paragraph: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        link: {
          'link-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
        },
      },
    },
    large: {
      brand: 'legacy',
      mode: 'dark',
      breakpoint: 'large',
      colors: {
        black: '#1F2635',
        'border.brand': '#8EDED0',
        'border.brand-alt': '#1A3D32',
        'border.disabled': '#28272529',
        'border.divider': '#FDFDFC33',
        'border.error': '#FD6C6F',
        'border.focused': '#4DA89C',
        'border.info': '#5C9CEF',
        'border.interactive': '#4DA89C',
        'border.inverse.disabled': '#28272566',
        'border.inverse.divider': '#2827251F',
        'border.inverse.interactive': '#3A9488',
        'border.inverse.primary': '#28272566',
        'border.inverse.secondary': '#28272529',
        'border.inverse.selected': '#236B61',
        'border.inverse.strong': '#1F2635',
        'border.primary': '#FDFDFC66',
        'border.secondary': '#FDFDFC29',
        'border.secondary-1.default': '#A0C462',
        'border.secondary-1.strong': '#F4F8E8',
        'border.secondary-1.subtle': '#5C7530',
        'border.secondary-2.default': '#EECA60',
        'border.secondary-2.strong': '#FDF8E8',
        'border.secondary-2.subtle': '#B5832C',
        'border.secondary-3.default': '#E39464',
        'border.secondary-3.strong': '#FDF0E8',
        'border.secondary-3.subtle': '#9E4C2A',
        'border.secondary-4.default': '#EE9F99',
        'border.secondary-4.strong': '#FDE8EC',
        'border.secondary-4.subtle': '#9B4138',
        'border.secondary-5.default': '#A38ABF',
        'border.secondary-5.low': '#64466C',
        'border.secondary-5.medium': '#CFC1E1',
        'border.secondary-5.strong': '#F3EEF7',
        'border.secondary-5.subtle': '#3A2640',
        'border.selected': '#236B61',
        'border.strong': '#FFFFFF',
        'border.success': '#96DF3C',
        'border.warning': '#E8C427',
        'component.button.bg.hover': '#28272533',
        'component.button.bg.inverted': '#1F2635',
        'component.button.bg.pressed': '#28272599',
        'component.button.bg.primary': '#FFFFFF',
        'component.button.bg.secondary': '#8EDED0',
        'component.button.bg.tertiary': '#3E3B38',
        'component.button.bg.transparent': '#FDFDFC66',
        'component.button.border.tertiary': '#FFFFFF',
        'component.button.icon.tertiary': '#FFFFFF',
        'component.button.label.tertiary': '#FFFFFF',
        'concept.ambassador.border': '#7C4D17',
        'concept.ambassador.icon': '#E8C427',
        'concept.ambassador.surface.default': '#E8C427',
        'concept.ambassador.surface.strong': '#F9F6C8',
        'concept.ambassador.surface.subtle': '#3D220B',
        'concept.ambassador.text': '#EDD441',
        'concept.exoneration.border': '#9D3D0F',
        'concept.exoneration.icon': '#FFAD54',
        'concept.exoneration.surface.default': '#4DA89C',
        'concept.exoneration.surface.low': '#B8ECE0',
        'concept.exoneration.surface.medium': '#8EDED0',
        'concept.exoneration.surface.strong': '#B8ECE0',
        'concept.exoneration.surface.subtle': '#1F2635',
        'concept.exoneration.text': '#FFC471',
        'concept.pension.border': '#3A5F15',
        'concept.pension.icon': '#96DF3C',
        'concept.pension.surface.default': '#5C9CEF',
        'concept.pension.surface.strong': '#D6E6FB',
        'concept.pension.surface.subtle': '#121A27',
        'concept.pension.text-on-dark': '#B3EC6A',
        'concept.pension.text-on-light': '#B3EC6A',
        'concept.plan.free.icon-on-surface': '#FFFFFF',
        'concept.plan.free.surface.default': '#5C9CEF',
        'concept.plan.free.surface.low': '#1C3C68',
        'concept.plan.free.surface.medium': '#ADCDF7',
        'concept.plan.free.surface.strong': '#D6E6FB',
        'concept.plan.free.surface.subtle': '#121A27',
        'concept.plan.free.text-on-surface': '#FFFFFF',
        'concept.plan.premium.accent': '#F7E9AB',
        'concept.plan.premium.border': '#4F3556',
        'concept.plan.premium.icon-on-surface': '#A38ABF',
        'concept.plan.premium.surface.default': '#A38ABF',
        'concept.plan.premium.surface.low': '#4F3556',
        'concept.plan.premium.surface.medium': '#CFC1E1',
        'concept.plan.premium.surface.strong': '#E5DAEF',
        'concept.plan.premium.surface.subtle': '#231728',
        'concept.plan.premium.text-on-surface': '#B8A4D0',
        'concept.trust-club.border': '#6E4C4E',
        'concept.trust-club.icon': '#FFBABC',
        'concept.trust-club.surface.default': '#FFBABC',
        'concept.trust-club.surface.strong': '#FFEEEE',
        'concept.trust-club.surface.subtle': '#261E20',
        'concept.trust-club.text-on-dark': '#FFCBCD',
        'concept.trust-club.text-on-light': '#FFCBCD',
        'gradient.bottom-tab-bar-end': '#161616E5',
        'gradient.bottom-tab-bar-start': '#16161600',
        'gradient.primary': '#16161600',
        'icon.brand': '#8EDED0',
        'icon.brand-alt': '#1F2635',
        'icon.disabled': '#FDFDFC66',
        'icon.emphasized': '#4DA89C',
        'icon.error': '#FD6C6F',
        'icon.info': '#85B5F3',
        'icon.interactive': '#4DA89C',
        'icon.inverse.disabled': '#28272566',
        'icon.inverse.interactive': '#3A9488',
        'icon.inverse.on-selected': '#4DA89C',
        'icon.inverse.primary': '#1F2635',
        'icon.inverse.secondary': '#6B6861',
        'icon.primary': '#FFFFFF',
        'icon.secondary': '#C6C3B9',
        'icon.secondary-1.default': '#A0C462',
        'icon.secondary-1.low': '#5C7530',
        'icon.secondary-1.medium': '#D2E4A8',
        'icon.secondary-1.strong': '#F4F8E8',
        'icon.secondary-1.subtle': '#344417',
        'icon.secondary-2.default': '#EECA60',
        'icon.secondary-2.low': '#B5832C',
        'icon.secondary-2.medium': '#F7E9AB',
        'icon.secondary-2.strong': '#FDF8E8',
        'icon.secondary-2.subtle': '#6A4B17',
        'icon.secondary-3.default': '#E39464',
        'icon.secondary-3.low': '#9E4C2A',
        'icon.secondary-3.medium': '#F8CAAA',
        'icon.secondary-3.strong': '#FDF0E8',
        'icon.secondary-3.subtle': '#5C2314',
        'icon.secondary-4.default': '#EE9F99',
        'icon.secondary-4.low': '#9B4138',
        'icon.secondary-4.medium': '#F5C2CB',
        'icon.secondary-4.strong': '#FDE8EC',
        'icon.secondary-4.subtle': '#521F1B',
        'icon.secondary-5.default': '#A38ABF',
        'icon.secondary-5.low': '#64466C',
        'icon.secondary-5.medium': '#CFC1E1',
        'icon.secondary-5.strong': '#F3EEF7',
        'icon.secondary-5.subtle': '#3A2640',
        'icon.selected': '#4DA89C',
        'icon.success': '#96DF3C',
        'icon.tertiary': '#6B6861',
        'icon.warning': '#EDD441',
        page: '#161616',
        'shadow.inner': '#FDFDFC33',
        'shadow.lg': '#28272599',
        'shadow.md': '#28272566',
        'shadow.sm': '#28272533',
        'shadow.xl': '#282725CC',
        'shadow.xs': '#2827251F',
        'state-layer.hover': '#FDFDFC14',
        'state-layer.hover-alt': '#28272529',
        'state-layer.hover-brand': '#B8ECE029',
        'state-layer.hover-on-color': '#FDFDFC33',
        'state-layer.inverse.hover': '#28272514',
        'state-layer.inverse.hover-brand': '#B8ECE033',
        'state-layer.inverse.hover-on-color': '#FDFDFC33',
        'state-layer.inverse.press': '#28272529',
        'state-layer.inverse.press-brand': '#B8ECE066',
        'state-layer.inverse.press-on-color': '#28272566',
        'state-layer.press': '#FDFDFC29',
        'state-layer.press-alt': '#28272566',
        'state-layer.press-brand': '#B8ECE066',
        'state-layer.press-on-color': '#FDFDFC66',
        'surface.brand.bold': '#E8F8F4',
        'surface.brand.bold-alt': '#B4ECDF',
        'surface.brand.default': '#4DA89C',
        'surface.brand.default-alt': '#4DA89C',
        'surface.brand.secondary-1.default': '#A0C462',
        'surface.brand.secondary-1.low': '#5C7530',
        'surface.brand.secondary-1.medium': '#D2E4A8',
        'surface.brand.secondary-1.strong': '#F4F8E8',
        'surface.brand.secondary-1.subtle': '#344417',
        'surface.brand.secondary-1.translucent.default': '#D2E4A833',
        'surface.brand.secondary-1.translucent.low': '#D2E4A814',
        'surface.brand.secondary-1.translucent.medium': '#D2E4A866',
        'surface.brand.secondary-1.translucent.strong': '#D2E4A899',
        'surface.brand.secondary-1.translucent.subtle': '#D2E4A80A',
        'surface.brand.secondary-2.default': '#F7E9AB',
        'surface.brand.secondary-2.low': '#B5832C',
        'surface.brand.secondary-2.medium': '#EECA60',
        'surface.brand.secondary-2.strong': '#FDF8E8',
        'surface.brand.secondary-2.subtle': '#6A4B17',
        'surface.brand.secondary-2.translucent.default': '#F2D87A33',
        'surface.brand.secondary-2.translucent.low': '#F2D87A14',
        'surface.brand.secondary-2.translucent.medium': '#F2D87A66',
        'surface.brand.secondary-2.translucent.strong': '#F2D87A99',
        'surface.brand.secondary-2.translucent.subtle': '#F2D87A0A',
        'surface.brand.secondary-3.default': '#EFA87A',
        'surface.brand.secondary-3.low': '#9E4C2A',
        'surface.brand.secondary-3.medium': '#F8CAAA',
        'surface.brand.secondary-3.strong': '#FDF0E8',
        'surface.brand.secondary-3.subtle': '#5C2314',
        'surface.brand.secondary-3.translucent.default': '#F8CAAA33',
        'surface.brand.secondary-3.translucent.low': '#F8CAAA14',
        'surface.brand.secondary-3.translucent.medium': '#F8CAAA66',
        'surface.brand.secondary-3.translucent.strong': '#F8CAAA99',
        'surface.brand.secondary-3.translucent.subtle': '#F8CAAA0A',
        'surface.brand.secondary-4.default': '#EE9F99',
        'surface.brand.secondary-4.low': '#9B4138',
        'surface.brand.secondary-4.medium': '#F5C2CB',
        'surface.brand.secondary-4.strong': '#FDE8EC',
        'surface.brand.secondary-4.subtle': '#521F1B',
        'surface.brand.secondary-4.translucent.default': '#F5C2CB33',
        'surface.brand.secondary-4.translucent.low': '#F5C2CB14',
        'surface.brand.secondary-4.translucent.medium': '#F5C2CB66',
        'surface.brand.secondary-4.translucent.strong': '#F5C2CB99',
        'surface.brand.secondary-4.translucent.subtle': '#F5C2CB0A',
        'surface.brand.secondary-5.default': '#A38ABF',
        'surface.brand.secondary-5.low': '#64466C',
        'surface.brand.secondary-5.medium': '#CFC1E1',
        'surface.brand.secondary-5.strong': '#F3EEF7',
        'surface.brand.secondary-5.subtle': '#3A2640',
        'surface.brand.secondary-5.translucent.default': '#CFC1E133',
        'surface.brand.secondary-5.translucent.low': '#CFC1E114',
        'surface.brand.secondary-5.translucent.medium': '#CFC1E166',
        'surface.brand.secondary-5.translucent.strong': '#CFC1E199',
        'surface.brand.secondary-5.translucent.subtle': '#CFC1E10A',
        'surface.brand.strong': '#E8F8F4',
        'surface.brand.strong-alt': '#E8F8F4',
        'surface.brand.subtle': '#236B61',
        'surface.brand.subtle-alt': '#236B61',
        'surface.brand.translucent.bold': '#B8ECE066',
        'surface.brand.translucent.bold-alt': '#B8ECE066',
        'surface.brand.translucent.default': '#B8ECE033',
        'surface.brand.translucent.strong': '#B8ECE066',
        'surface.brand.translucent.strong-alt': '#B8ECE066',
        'surface.brand.translucent.subtle': '#B8ECE014',
        'surface.default': '#282725',
        'surface.disabled': '#FDFDFC33',
        'surface.error.default': '#FD6C6F',
        'surface.error.low': '#BE171B',
        'surface.error.medium': '#FFC8C9',
        'surface.error.strong': '#FEF2F2',
        'surface.error.subtle': '#470809',
        'surface.error.translucent.default': '#F53E4266',
        'surface.error.translucent.strong': '#F53E4299',
        'surface.error.translucent.subtle': '#F53E4229',
        'surface.info.default': '#5C9CEF',
        'surface.info.low': '#255594',
        'surface.info.medium': '#ADCDF7',
        'surface.info.strong': '#EBF3FE',
        'surface.info.subtle': '#121A27',
        'surface.info.translucent.default': '#3383EB66',
        'surface.info.translucent.strong': '#3383EB99',
        'surface.info.translucent.subtle': '#3383EB29',
        'surface.interactive': '#4DA89C',
        'surface.inverse.default': '#FFFFFF',
        'surface.inverse.disabled': '#28272533',
        'surface.inverse.primary-neutral': '#9B988C',
        'surface.inverse.secondary-neutral': '#6B6861',
        'surface.inverse.selected': '#236B61',
        'surface.inverse.selected-strong': '#FFFFFF',
        'surface.inverse.tertiary-neutral': '#3E3B38',
        'surface.overlay': '#28272566',
        'surface.primary': '#B8ECE014',
        'surface.primary-alt': '#0E2720',
        'surface.primary-neutral': '#28272599',
        'surface.secondary': '#B8ECE01F',
        'surface.secondary-alt': '#1A3D32',
        'surface.secondary-neutral': '#FDFDFC14',
        'surface.selected': '#236B61',
        'surface.selected-strong': '#4DA89C',
        'surface.strong-neutral': '#282725CC',
        'surface.success.default': '#96DF3C',
        'surface.success.low': '#457714',
        'surface.success.medium': '#CDF496',
        'surface.success.strong': '#F6FDE8',
        'surface.success.subtle': '#182C07',
        'surface.success.translucent.default': '#77C41E66',
        'surface.success.translucent.strong': '#77C41E99',
        'surface.success.translucent.subtle': '#77C41E29',
        'surface.tertiary': '#B8ECE029',
        'surface.tertiary-alt': '#315B4A',
        'surface.tertiary-neutral': '#FDFDFC29',
        'surface.translucent.default': '#2827250A',
        'surface.translucent.disabled': '#FDFDFC1F',
        'surface.translucent.primary': '#B8ECE014',
        'surface.translucent.primary-alt': '#B8ECE014',
        'surface.translucent.primary-neutral': '#FDFDFC14',
        'surface.translucent.secondary': '#B8ECE029',
        'surface.translucent.secondary-alt': '#B8ECE029',
        'surface.translucent.secondary-neutral': '#FDFDFC29',
        'surface.translucent.selected': '#B8ECE029',
        'surface.translucent.strong-neutral': '#FDFDFC66',
        'surface.translucent.tertiary': '#B8ECE066',
        'surface.translucent.tertiary-alt': '#B8ECE033',
        'surface.translucent.tertiary-neutral': '#FDFDFC33',
        'surface.warning.default': '#E8C427',
        'surface.warning.low': '#956213',
        'surface.warning.medium': '#F5EA93',
        'surface.warning.strong': '#FCFBEA',
        'surface.warning.subtle': '#3D220B',
        'surface.warning.translucent.default': '#D8AD1A66',
        'surface.warning.translucent.strong': '#D8AD1A99',
        'surface.warning.translucent.subtle': '#D8AD1A29',
        'text.brand': '#8EDED0',
        'text.brand-alt': '#1F2635',
        'text.disabled': '#FDFDFC66',
        'text.emphasized': '#4DA89C',
        'text.error': '#FD6C6F',
        'text.info': '#85B5F3',
        'text.interactive': '#4DA89C',
        'text.inverse.disabled': '#28272566',
        'text.inverse.emphasized': '#236B61',
        'text.inverse.interactive': '#3A9488',
        'text.inverse.primary': '#282725',
        'text.inverse.secondary': '#6B6861',
        'text.primary': '#FFFFFF',
        'text.secondary': '#C6C3B9',
        'text.secondary-1.default': '#A0C462',
        'text.secondary-1.low': '#5C7530',
        'text.secondary-1.medium': '#D2E4A8',
        'text.secondary-1.strong': '#F4F8E8',
        'text.secondary-1.subtle': '#344417',
        'text.secondary-2.default': '#F7E9AB',
        'text.secondary-2.low': '#B5832C',
        'text.secondary-2.medium': '#EECA60',
        'text.secondary-2.strong': '#FDF8E8',
        'text.secondary-2.subtle': '#6A4B17',
        'text.secondary-3.default': '#EFA87A',
        'text.secondary-3.low': '#9E4C2A',
        'text.secondary-3.medium': '#F8CAAA',
        'text.secondary-3.strong': '#FDF0E8',
        'text.secondary-3.subtle': '#5C2314',
        'text.secondary-4.default': '#EE9F99',
        'text.secondary-4.low': '#9B4138',
        'text.secondary-4.medium': '#F5C2CB',
        'text.secondary-4.strong': '#FDE8EC',
        'text.secondary-4.subtle': '#521F1B',
        'text.secondary-5.default': '#A38ABF',
        'text.secondary-5.low': '#64466C',
        'text.secondary-5.medium': '#CFC1E1',
        'text.secondary-5.strong': '#F3EEF7',
        'text.secondary-5.subtle': '#3A2640',
        'text.selected': '#4DA89C',
        'text.success': '#96DF3C',
        'text.tertiary': '#6B6861',
        'text.warning': '#EDD441',
        white: '#FFFFFF',
        'white-label.footer.footer-bg': '#1F2635',
        'white-label.header.bg': '#161616',
        'white-label.header.on-header': '#FFFFFF',
        'white-label.headerSubtext': '#FFFFFF',
        'white-label.highlight': '#FFFFFF',
        'white-label.highlightText': '#FFFFFF',
        'white-label.notificationLogoBackground': '#FFFFFF',
        'white-label.publish-button.bg.header-bar': '#FFFFFF',
        'white-label.publish-button.bg.mobile-bottom-tab-bar': '#FFFFFF',
        'white-label.publish-button.icon.header-bar': '#1F2635',
        'white-label.publish-button.icon.mobile-bottom-tab-bar': '#1F2635',
        'white-label.publish-button.label.primary': '#1F2635',
        'white-label.splash': '#B8ECE0',
        'white-label.theme.icon.on-brand-accent': '#1F2635',
        'white-label.theme.surface.accent': '#FFFFFF',
        'white-label.theme.surface.primary': '#1F2635',
        'white-label.theme.text.on-brand-accent': '#1F2635',
      },
      responsive: {
        'border-width.bold': '4',
        'border-width.emphasized': '2',
        'border-width.standard': '1.5',
        'border-width.subtle': '1',
        'motion.distance.component-enter': '12',
        'motion.distance.feedback': '4',
        'motion.distance.overlay-enter': '24',
        'motion.distance.page-enter': '32',
        'motion.duration.component-transition': '[object Object]',
        'motion.duration.feedback': '[object Object]',
        'motion.duration.micro-transition': '[object Object]',
        'motion.duration.overlay-transition': '[object Object]',
        'motion.duration.page-transition': '[object Object]',
        'motion.duration.passive': '[object Object]',
        'motion.easing.continuous': '0,0,1,1',
        'motion.easing.emphasize': '0.05000000074505806,0.699999988079071,0.10000000149011612,1',
        'motion.easing.enter': '0,0,0,1',
        'motion.easing.exit': '0.4000000059604645,0,1,1',
        'motion.easing.move': '0.20000000298023224,0,0,1',
        'motion.scale.emphasize': '1.0199999809265137',
        'motion.scale.enter': '0.9599999785423279',
        'motion.scale.press': '0.9800000190734863',
        'motion.stagger.relaxed': '[object Object]',
        'motion.stagger.standard': '[object Object]',
        'motion.stagger.tight': '[object Object]',
        'radius.component.fields.input': '16',
        'radius.component.publish-button.button-radius': '8',
        'radius.full': '1000',
        'radius.lg': '16',
        'radius.md': '12',
        'radius.none': '0',
        'radius.sm': '8',
        'radius.xl': '24',
        'radius.xs': '4',
        'radius.xxl': '32',
        'radius.xxs': '2',
        'shadow.blur.lg': '32',
        'shadow.blur.md': '16',
        'shadow.blur.sm': '8',
        'shadow.blur.xl': '48',
        'shadow.blur.xs': '4',
        'shadow.offset-y.lg': '8',
        'shadow.offset-y.md': '4',
        'shadow.offset-y.sm': '2',
        'shadow.offset-y.xl': '16',
        'shadow.offset-y.xs': '1',
        'sizing.body.max-width': '1440',
        'sizing.body.min-width': '1280',
        'sizing.component.button.height.large': '56',
        'sizing.component.button.height.large-icn-button': '48',
        'sizing.component.button.height.medium': '40',
        'sizing.component.button.height.small': '32',
        'sizing.component.header.max-width': '1920',
        'sizing.component.header.min-width': '1280',
        'sizing.general.0': '0',
        'sizing.general.x0,25': '1',
        'sizing.general.x0,5': '2',
        'sizing.general.x1': '4',
        'sizing.general.x10': '40',
        'sizing.general.x100': '400',
        'sizing.general.x12': '48',
        'sizing.general.x120': '480',
        'sizing.general.x14': '56',
        'sizing.general.x140': '560',
        'sizing.general.x150': '600',
        'sizing.general.x16': '64',
        'sizing.general.x160': '640',
        'sizing.general.x18': '72',
        'sizing.general.x180': '720',
        'sizing.general.x2': '8',
        'sizing.general.x20': '80',
        'sizing.general.x200': '800',
        'sizing.general.x22': '88',
        'sizing.general.x24': '96',
        'sizing.general.x3': '12',
        'sizing.general.x30': '120',
        'sizing.general.x36': '144',
        'sizing.general.x4': '16',
        'sizing.general.x40': '160',
        'sizing.general.x5': '20',
        'sizing.general.x50': '200',
        'sizing.general.x6': '24',
        'sizing.general.x60': '240',
        'sizing.general.x7': '28',
        'sizing.general.x70': '280',
        'sizing.general.x8': '32',
        'sizing.general.x80': '320',
        'sizing.general.x90': '360',
        'sizing.icon.default': '24',
        'sizing.icon.lg': '32',
        'sizing.icon.s': '16',
        'sizing.icon.sm': '20',
        'sizing.icon.xl': '56',
        'sizing.icon.xs': '12',
        'spacing.general.0': '0',
        'spacing.general.x0,5': '2',
        'spacing.general.x1': '4',
        'spacing.general.x10': '40',
        'spacing.general.x12': '48',
        'spacing.general.x14': '56',
        'spacing.general.x16': '64',
        'spacing.general.x18': '72',
        'spacing.general.x2': '8',
        'spacing.general.x20': '80',
        'spacing.general.x22': '88',
        'spacing.general.x24': '96',
        'spacing.general.x3': '12',
        'spacing.general.x30': '120',
        'spacing.general.x36': '144',
        'spacing.general.x4': '16',
        'spacing.general.x5': '20',
        'spacing.general.x6': '24',
        'spacing.general.x7': '28',
        'spacing.general.x8': '32',
        'spacing.semantic.bottom-safe-zone': '36',
        'spacing.semantic.line-height-fix': '2',
        'spacing.semantic.page-margin': '48',
        'typography.font-size.body.base': '16',
        'typography.font-size.body.caption-base': '10',
        'typography.font-size.body.caption-large': '12',
        'typography.font-size.body.large': '18',
        'typography.font-size.body.small': '14',
        'typography.font-size.body.x-large': '20',
        'typography.font-size.body.x-small': '12',
        'typography.font-size.header.display-1': '56',
        'typography.font-size.header.display-2': '64',
        'typography.font-size.header.large': '48',
        'typography.font-size.header.medium': '40',
        'typography.font-size.header.small': '36',
        'typography.font-size.header.x-small': '32',
        'typography.font-size.link.link-base': '16',
        'typography.font-size.link.link-large': '20',
        'typography.font-size.link.link-small': '14',
        'typography.letter-spacing.body.base': '0',
        'typography.letter-spacing.body.caption': '0',
        'typography.letter-spacing.body.large': '0',
        'typography.letter-spacing.body.small': '0',
        'typography.letter-spacing.body.x-large': '0',
        'typography.letter-spacing.body.x-small': '0',
        'typography.letter-spacing.header.display-1': '0',
        'typography.letter-spacing.header.display-2': '0',
        'typography.letter-spacing.header.large': '0',
        'typography.letter-spacing.header.medium': '0',
        'typography.letter-spacing.header.small': '0',
        'typography.letter-spacing.header.x-small': '0',
      },
      styles: {
        header: {
          'display-2': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '64',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'display-1': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '56',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '48',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '48', letterSpacing: '0', lineHeight: 'normal' },
          },
          medium: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '40',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'medium-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '40', letterSpacing: '0', lineHeight: 'normal' },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '36',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '36', letterSpacing: '0', lineHeight: 'normal' },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '32',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '32', letterSpacing: '0', lineHeight: 'normal' },
          },
        },
        body: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '700', fontSize: '18', letterSpacing: '0', lineHeight: '120%' },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '400', fontSize: '14', letterSpacing: '0', lineHeight: '120%' },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        caption: {
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        paragraph: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        link: {
          'link-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
        },
      },
    },
  },
} as const;
